<template>
    <div>

         <div class="row">
             <div class="col-sm-12 mb-2">
                <button class="ix-btn ix-btn-state green" type="button" @click="openSideBar">Injecter à partir d'étude</button>
            </div>
            <inject-study 
                :studyUrl="urlStudy" 
                :predictionTypes="JSON.parse(predictionTypes)"
                :purchaseTypes="JSON.parse(purchaseTypes)"
                :typeMargin="margin_type"
                v-on:inject-predictions="injectPredictions($event)"
                v-on:remove-inject-predictions="deleteInjectPrediction($event)">
            </inject-study>
        </div>

        <div v-show="isLotMode">
            <h2 class="ix-page-title-secondary mt-4">Synthèse globale de l'étude</h2>
            <div class="row mb-4 mt-2" v-if="!loading">
                <div class="col-sm-12 col-md-12 col-lg-6" v-show="!isDeal">
                    <div class="form-group row">
                        <label for="quantity" class="col-sm-2 col-form-label">Quantité totale</label>
                        <div class="col-sm-4">
                            <div class="input-group">
                                <input type="number" class="form-control" v-model="quantity" id="quantity" name="quantity" step="0.01" min="0.01">
                                <input type="text" class="form-control" v-model="unit" id="unit" name="unit" placeholder="m2, m3, tonnes, kg.." :required="quantity != '' && quantity != null">
                            </div>
                            <small class="ix-text-secondary">Pré-remplie automatiquement à partir des quantités des lots (somme si même unité, sinon reprend le dernier lot) — modifiable manuellement.</small>
                        </div>

                         <label for="quantity" class="col-sm-2 col-form-label">Nombre d'heures travaillées</label>
                            <div class="col-sm-4">
                                <div class="input-group">
                                    <input type="number" class="form-control" v-model="hours_per_day" id="hours_per_day" name="hours_per_day" step="0.01" min="0.01" required>
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="inputGroup-sizing-sm">h / j / personne</span>
                                    </div>
                                </div>
                            </div>
                    </div>

                    <div class="form-group row">
                        <label for="total_margin" class="col-sm-2 col-form-label">
                            Ratio
                            <span v-b-tooltip title="PV total / quantité">
                                <i class="fas fa-question-circle"></i>
                            </span>
                        </label>
                        <div class="col-sm-4 text-right">
                            <span class="ix-text-small ix-text-red" v-if="quantity == 0">Impossible de calculer le résultat sur une quantité égale à 0</span>
                            <div v-if="quantity != 0">
                                <span class="ix-text-secondary ix-text-small" v-if="ratio == null">Veuillez saisir une quantité et son unité pour permettre l'affichage du résultat</span>

                                <div v-if="ratio != null">
                                    <span class="ix-text-large ix-text-bold">{{ currency(ratio) }}</span> / {{ unit }}
                                </div>
                            </div>
                        </div>

                        <label for="total_margin" class="col-sm-2 col-form-label">
                            Total d'heures prévisionnelles
                        </label>
                        <div class="col-sm-4 text-right">
                            {{ total_hours }}h soit <span class="ix-text-large ix-text-bold">{{ total_day_man }}j / personne</span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="total_margin" class="col-sm-4 col-form-label">
                            Marge dégagée
                            <span v-b-tooltip title="PV total - PR total">
                                <i class="fas fa-question-circle"></i>
                            </span>
                        </label>
                        <div class="col-sm-8 text-right">
                            <span class="ix-text-large ix-text-bold" :class="{ 'ix-text-red': total_margin < 0 }">{{ currency(total_margin) }}</span>
                        </div>
                    </div>

                </div>

                <div class="col-sm-12 col-md-12 col-lg-6">
                    <div class="ix-table-box">
                        <table class="ix-table">
                            <thead>
                                <tr>
                                    <th style="width: 20px;"></th>
                                    <th></th>
                                    <th class="text-right">Prix de revient HT</th>
                                    <th class="text-center" style="width: 180px;">
                                        Tx {{ margin_type == 2 ? 'marque' : 'marge' }} C.
                                        <span v-b-tooltip title="Marge conseillée">
                                            <i class="fas fa-question-circle"></i>
                                        </span>
                                    </th>
                                    <th class="text-center">
                                        Tx {{ margin_type == 2 ? 'marque' : 'marge' }} D.
                                        <span v-b-tooltip title="Marge dégagée">
                                            <i class="fas fa-question-circle"></i>
                                        </span>
                                    </th>
                                    <th class="text-right">Prix de vente HT</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-center">
                                        <i class="far fa-user"></i>
                                    </td>
                                    <td>
                                        <span class="ix-text-bold">Main d'oeuvre</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_workforce) }}</td>
                                    <td>
                                        <div class="input-group input-group-sm">
                                            <input type="number" class="form-control text-center" :class="{ 'text-danger': parseFloat(margin_workforce) < 0 }" name="margin_workforce" v-model="margin_workforce" required :min="marginBounds.min" :max="marginBounds.max" step="0.01">
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                                <button class="ix-btn ix-btn-icon transparent" type="button" @click="updatePredictionsMargin(1, margin_workforce)" :disabled="margin_workforce === '' || margin_workforce === null" :title="'Mettre à jour les prévisions de la catégorie avec ce taux de ' + (margin_type == 2 ? 'marque' : 'marge')">
                                                    <i class="far fa-sync"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <span :class="{ 'ix-text-red': avg_margin_workforce < 0 }">{{ avg_margin_workforce }}%</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_workforce_selling) }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <i class="far fa-shopping-bag"></i>
                                    </td>
                                    <td>
                                        <span class="ix-text-bold">Achats</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_purchases) }}</td>
                                    <td>
                                        <div class="input-group input-group-sm">
                                            <input type="number" class="form-control text-center" :class="{ 'text-danger': parseFloat(margin_purchases) < 0 }" name="margin_purchases" v-model="margin_purchases" required :min="marginBounds.min" :max="marginBounds.max" step="0.01">
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                                <button class="ix-btn ix-btn-icon transparent" type="button" @click="updatePredictionsMargin(2, margin_purchases)" :disabled="margin_purchases === '' || margin_purchases === null" :title="'Mettre à jour les prévisions de la catégorie avec ce taux de ' + (margin_type == 2 ? 'marque' : 'marge')">
                                                    <i class="far fa-sync"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <span :class="{ 'ix-text-red': avg_margin_purchases < 0 }">{{ avg_margin_purchases }}%</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_purchases_selling) }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <i class="far fa-cube"></i>
                                    </td>
                                    <td>
                                        <span class="ix-text-bold">Stocks</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_stocks) }}</td>
                                    <td>
                                        <div class="input-group input-group-sm">
                                            <input type="number" class="form-control text-center" :class="{ 'text-danger': parseFloat(margin_stocks) < 0 }" name="margin_stocks" v-model="margin_stocks" required :min="marginBounds.min" :max="marginBounds.max" step="0.01">
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                                <button class="ix-btn ix-btn-icon transparent" type="button" @click="updatePredictionsMargin(3, margin_stocks)" :disabled="margin_stocks === '' || margin_stocks === null" :title="'Mettre à jour les prévisions de la catégorie avec ce taux de ' + (margin_type == 2 ? 'marque' : 'marge')">
                                                    <i class="far fa-sync"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <span :class="{ 'ix-text-red': avg_margin_stocks < 0 }">{{ avg_margin_stocks }}%</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_stocks_selling) }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <i class="far fa-cog"></i>
                                    </td>
                                    <td>
                                        <span class="ix-text-bold">Matériels</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_equipments) }}</td>
                                    <td>
                                        <div class="input-group input-group-sm">
                                            <input type="number" class="form-control text-center" :class="{ 'text-danger': parseFloat(margin_equipments) < 0 }" name="margin_equipments" v-model="margin_equipments" required :min="marginBounds.min" :max="marginBounds.max" step="0.01">
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                                <button class="ix-btn ix-btn-icon transparent" type="button" @click="updatePredictionsMargin(4, margin_equipments)" :disabled="margin_equipments === '' || margin_equipments === null" :title="'Mettre à jour les prévisions de la catégorie avec ce taux de ' + (margin_type == 2 ? 'marque' : 'marge')">
                                                    <i class="far fa-sync"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <span :class="{ 'ix-text-red': avg_margin_equipments < 0 }">{{ avg_margin_equipments }}%</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_equipments_selling) }}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="ix-text-bold">{{ hasOptionalPredictions ? 'Total sans option' : 'Total' }}</td>
                                    <td class="text-right ix-text-bold">
                                        {{ currency(total) }}
                                    </td>
                                    <td></td>
                                    <td class="text-center">
                                        <span :class="{ 'ix-text-red': avg_margin < 0 }">{{ avg_margin }}%</span>
                                        <input type="hidden" name="margin_type" v-model="margin_type">
                                    </td>
                                    <td class="text-right ix-text-large ix-text-bold">
                                        {{ currency(total_selling) }}
                                    </td>
                                </tr>
                                <tr v-if="hasOptionalPredictions">
                                    <td class="text-center">
                                        <i class="far fa-plus-circle"></i>
                                    </td>
                                    <td class="ix-text-bold">Total optionnel <span class="ix-badge optional ml-1">{{ optionalCount }} option{{ optionalCount > 1 ? 's' : '' }}</span></td>
                                    <td class="text-right">{{ currency(total_optional) }}</td>
                                    <td></td>
                                    <td class="text-center">
                                        <span :class="{ 'ix-text-red': avg_optional_margin < 0 }">{{ avg_optional_margin }}%</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_optional_selling) }}</td>
                                </tr>
                                <tr v-if="hasOptionalPredictions">
                                    <td></td>
                                    <td class="ix-text-bold">Total général</td>
                                    <td class="text-right ix-text-bold">{{ currency(total + total_optional) }}</td>
                                    <td></td>
                                    <td class="text-center">
                                        <span :class="{ 'ix-text-red': avg_margin_with_options < 0 }">{{ avg_margin_with_options }}%</span>
                                    </td>
                                    <td class="text-right ix-text-large ix-text-bold">{{ currency(total_selling + total_optional_selling) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="ix-lots-predictions">
            <div class="ix-lot-cards mt-4">
                <div v-for="(lot, index) in lots" :key="lot.uniq"
                     class="ix-lot-card"
                     :class="{'active': index == currentIndex || (currentLot != null && currentLot.id != null && currentLot.id == lot.id), 'incomplete': lotIsIncomplete(lot) && index != currentIndex, 'complete': !lotIsIncomplete(lot) && index != currentIndex}"
                     @click="selectLot(index, lot)">
                    <div class="ix-lot-card-header">
                        <i class="fas fa-puzzle-piece"></i>
                        <span class="ix-lot-card-name" v-html="truncate(lot.name || 'Lot sans nom', 22)"></span>
                        <span class="ix-lot-card-state" :title="lotIsIncomplete(lot) && index != currentIndex ? 'Lot incomplet' : 'Lot complet'"></span>
                    </div>
                    <div class="ix-lot-card-price">{{ currency(lotTotalSelling(lot)) }} HT</div>
                    <span class="ix-lot-card-optional" v-if="lot.is_optional"><i class="fas fa-plus-circle"></i> En option</span>
                    <div class="ix-lot-card-warnings" v-if="lotMissingItems(lot).length > 0 && index != currentIndex">
                        <span class="ix-lot-card-warning" v-for="item in lotMissingItems(lot)" :key="item">
                            <i class="fas fa-exclamation-circle"></i> {{ item }}
                        </span>
                    </div>
                </div>
                <div class="ix-lot-card ix-lot-card-add" v-show="canAddLot" @click="addLotRow(null, lots.length)">
                    <i class="fas fa-plus"></i>
                    <span>Nouveau lot</span>
                </div>
            </div>
            <div class="ix-lot-content-panel text-center ix-text-secondary py-4" v-if="isLotMode && lots.length == 0">
                Aucun lot pour le moment. Cliquez sur « Nouveau lot » pour en créer un.
                <div v-if="canSwitchLotMode">
                    <button type="button" class="ix-btn link mt-2" @click="switchToNoLotMode()"><i class="far fa-exchange"></i> Passer en mode non alloti</button>
                </div>
            </div>
            <!-- Option désactivée : dilutions existantes en consultation seule, sans action -->
            <!-- Marge basse : le panneau du lot sélectionné suit directement -->
            <div class="mt-3 mb-4" v-if="((overheadDilutionEnabled === true || overheadDilutions.length > 0) && lots && lots.length > 0) || (overheadDilutionEnabled === true && pendingDilution)">
                <button type="button" class="ix-btn ix-btn-state overhead-dilution-trigger" v-if="overheadDilutionEnabled === true" @click="openOverheadDilutionModal"><i class="far fa-percent"></i> Créer une dépense</button>
                <template v-if="overheadDilutionEnabled === true && dilutionSuspended && !pendingDilution">
                    <button type="button" class="ix-btn ix-btn-state ml-2" @click="$refs.overheadDilutionModal.resume()"><i class="far fa-undo"></i> Reprendre la dépense</button>
                    <span class="ix-text-small ix-text-secondary ml-2">Dépense en cours de saisie</span>
                </template>

                <div class="alert alert-warning mt-3 mb-0" v-if="overheadDilutionEnabled === true && pendingDilution">
                    <div class="d-flex flex-wrap align-items-center">
                        <div class="mr-auto">
                            <strong><i class="far fa-hourglass-half"></i> Dépense en attente d'enregistrement</strong>
                            <span class="d-block ix-text-small">
                                {{ pendingDilution.operation === 'update' ? 'Modification de la dépense' : 'Nouvelle dépense' }} « {{ pendingDilution.designation }} » : elle sera enregistrée en même temps que l'étude.
                            </span>
                            <span class="d-block ix-text-small" v-if="pendingDilution.notice">{{ pendingDilution.notice }}</span>
                            <span class="d-block ix-text-small" v-if="pendingDilutionMissingLots.length > 0">
                                <i class="fas fa-exclamation-triangle"></i> Lot{{ pendingDilutionMissingLots.length > 1 ? 's' : '' }} retiré{{ pendingDilutionMissingLots.length > 1 ? 's' : '' }} de la répartition car supprimé{{ pendingDilutionMissingLots.length > 1 ? 's' : '' }} : {{ pendingDilutionMissingLots.join(', ') }}
                            </span>
                            <span class="d-block ix-text-small ix-text-red" v-if="pendingDilutionPercentageGap && pendingDilutionPositions.length > 0">
                                <i class="fas fa-exclamation-circle"></i> Les pourcentages ne totalisent plus 100 %. Reprenez la dépense pour les corriger.
                            </span>
                            <span class="d-block ix-text-small ix-text-red" v-if="pendingDilutionPositions.length === 0">
                                <i class="fas fa-exclamation-circle"></i> La dépense n'a plus aucun lot. Reprenez-la pour choisir au moins un lot, ou abandonnez-la.
                            </span>
                        </div>
                        <div class="text-nowrap mt-2 mt-md-0">
                            <button type="button" class="ix-btn ix-btn-state" @click="resumePendingDilution()"><i class="far fa-undo"></i> Reprendre la dépense</button>
                            <button type="button" class="ix-btn transparent ml-1" @click="discardPendingDilution"><i class="far fa-trash"></i> Abandonner</button>
                        </div>
                    </div>
                </div>

                <div class="ix-table-box mt-3 mb-0" v-if="overheadDilutions.length > 0">
                    <table class="ix-table">
                        <thead>
                            <tr>
                                <th>Dépense</th>
                                <th>Lots</th>
                                <th class="text-right">PR HT</th>
                                <th class="text-center">Tx {{ margin_type == 2 ? 'marque' : 'marge' }}</th>
                                <th class="text-right">PV HT</th>
                                <th v-if="overheadDilutionEnabled === true"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="dilution in overheadDilutions" :key="'overhead-dilution-' + dilution.id">
                                <td>
                                    {{ dilution.designation }}
                                    <span class="badge badge-warning ml-1" v-if="isStaleDilution({overhead_dilution_id: dilution.id})" v-b-tooltip.hover :title="staleDilutionTitle({overhead_dilution_id: dilution.id})"><i class="fas fa-exclamation-triangle"></i> Répartition à mettre à jour</span>
                                    <span class="badge badge-warning ml-1" v-else-if="overheadDilutionEnabled === true && unsavedDilutionChanges[dilution.id]" v-b-tooltip.hover :title="unsavedDilutionTitle(dilution.id)"><i class="fas fa-sync-alt"></i> À recalculer</span>
                                </td>
                                <td>
                                    <div class="d-flex flex-wrap align-items-center">
                                        <span
                                            v-for="(name, index) in dilutionLotList(dilution).slice(0, expandedDilutionLots[dilution.id] ? undefined : 3)"
                                            :key="index"
                                            class="badge badge-light border mr-1 mb-1 px-2 py-1"
                                        >
                                            <i class="fas fa-puzzle-piece text-primary mr-1"></i>{{ name }}
                                        </span>
                                        <button
                                            v-if="dilutionLotList(dilution).length > 3"
                                            type="button"
                                            class="btn btn-sm mb-1 mr-1 px-2 py-1 font-weight-bold"
                                            style="color: #2563eb; background-color: #eff6ff; border: 1px solid #bfdbfe; border-radius: 5px; font-size: 75%; line-height: 1; vertical-align: middle;"
                                            :aria-expanded="!!expandedDilutionLots[dilution.id]"
                                            @click="toggleDilutionLots(dilution.id)"
                                        >
                                            <span v-if="expandedDilutionLots[dilution.id]">
                                                Réduire <i class="fas fa-chevron-up ml-1"></i>
                                            </span>
                                            <span v-else>
                                                +{{ dilutionLotList(dilution).length - 3 }}
                                                <i class="fas fa-chevron-down ml-1"></i>
                                            </span>
                                        </button>
                                    </div>
                                    <span class="ix-text-small ix-text-secondary d-block" v-if="overheadDilutionEnabled !== true">Quantité totale : {{ formatNumber(dilution.total_quantity, 3) }} {{ dilution.unit }}</span>
                                </td>
                                <td class="text-right">{{ currency(dilution.amount) }}</td>
                                <td class="text-center">{{ formatNumber(dilution.margin, 2) }} %</td>
                                <td class="text-right">{{ currency(dilution.selling) }}</td>
                                <td class="text-right text-nowrap" v-if="overheadDilutionEnabled === true">
                                    <button type="button" class="ix-btn transparent" :disabled="dilutionBusy" @click="editOverheadDilution(dilution)"><i class="far fa-pen"></i> Modifier la dépense</button>
                                    <button type="button" class="ix-btn transparent" :disabled="dilutionBusy" @click="recalculateOverheadDilution(dilution)"><i class="far fa-sync-alt"></i> Recalculer</button>
                                    <button type="button" class="ix-btn transparent" :disabled="dilutionBusy" @click="cancelOverheadDilution(dilution)"><i class="far fa-trash"></i> Annuler la dépense</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="ix-lot-content-panel" v-show="lots && lots.length > 0">
                <div class="ix-lot-content-header">
                    <div class="ix-lot-content-header-left">
                        <i class="fas fa-puzzle-piece"></i>
                        <span class="ix-lot-content-header-name" v-html="activeLot ? (activeLot.name || 'Lot sans nom') : ''"></span>
                    </div>
                    <div class="ix-lot-content-header-right">
                        <span class="ix-lot-content-header-price" v-if="activeLot">{{ currency(lotTotalSelling(activeLot)) }} HT</span>
                    </div>
                </div>
                <div class="ix-lot-content-body tab-content">
                <h2 class="ix-page-title-secondary mt-4">Prévisions</h2>
                <div class="tab-pane" :class="{'active': index == currentIndex || (currentLot != null && currentLot.id != null && currentLot.id == lot.id)}" v-for="(lot, index) in lots" :key="lot.uniq" :id="'tab-' + index" role="tabpanel" :aria-labelledby="index + '-tab'">
                      <div class="row mb-2">
                        <div class="col-sm-10"></div>
                        <div class="col-sm-1 text-right">
                                <div class="input-group input-group-sm mb-3">
                                    <input type="number" step="1" class="form-control" min="1"   v-model="multiplier">
                                    <div class="input-group-append">
                                        <button class="btn btn-sm btn-primary" aria-placeholder="Nombre de lot a dupliquer" type="button" @click="duplicateLot(lot)"><i class="far fa-copy"></i></button>
                                    </div>
                                </div>
                        </div>
                        <div class="col-sm-1 text-right">
                                <button class="btn btn-sm btn-danger" type="button" @click="removeLot(index)"><i class="fas fa-trash"></i> Supprimer</button>
                        </div>
                        
                    </div>
                    <prediction-lot-form :lot="lot" :index="index" :lotRoute="lotRoute" :options-enabled="canEditOptions"></prediction-lot-form>
                    <input type="hidden" :value="lot.lot_quantity" :name="'lots[' + index + '][lot_quantity]'">
                  
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="ix-table-box mb-3">
                                <table class="ix-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 30px;"></th>
                                            <th style="width: 30px;">
                                                <span data-toggle="tooltip" data-placement="top" title="Définir comme titre"><i class="far fa-text"></i></span>
                                            </th>
                                            <th style="width: 150px;">Catégorie</th>
                                            <th style="width: 150px;">Référence</th>
                                            <th>Désignation</th>
                                            <th style="width: 120px;">Qté</th>
                                            <th class="text-right" style="width: 180px;">Prix de revient HT</th>
                                            <th class="text-center" style="width: 130px;">
                                                Tx {{ margin_type == 2 ? 'marque' : 'marge' }}
                                            </th>
                                            <th class="text-right" style="width: 180px;">Prix de vente HT</th>
                                            <th class="text-right" style="width: 180px;">Total vente HT</th>
                                            <th style="width: 120px;"></th>
                                        </tr>
                                    </thead>
                                    <draggable v-model="lot.predictions" tag="tbody" handle=".handle-line" v-if="!loading">
                                        <tr v-for="(prediction, i) in lot.predictions" is="prediction-lot-line-form"
                                            v-bind:key="prediction.uniq"
                                            :ref="prediction.uniq"
                                            :lot="lot"
                                            :prediction="prediction"
                                            :index="i"
                                            :lot-index="index"
                                            :can-toggle-optional="false"
                                            :suggestionsRoute="suggestionsRoute"
                                            :types="JSON.parse(predictionTypes)"
                                            :purchase-types="JSON.parse(purchaseTypes)"
                                            :default-margin-workforce="margin_workforce"
                                            :default-margin-purchases="margin_purchases"
                                            :default-margin-stocks="margin_stocks"
                                            :default-margin-equipments="margin_equipments"
                                            :default-hourly-rate="default_hourly_rate"
                                            :margin-type="margin_type"
                                            :can-hide="canHidePrediction(prediction)"
                                            :shows-hidden-flag="showsHiddenFlag(prediction)"
                                            v-on:prediction-editing-started="checkIfNewRowNeeded($event)"
                                            v-on:prediction-deleted="deleteRow($event)"
                                            v-on:prediction-toggle-optional="togglePredictionOptional($event)"
                                        ></tr>
                                    </draggable>
                                    <tbody v-if="!loading && lot.dilution_lines && lot.dilution_lines.length > 0" class="overhead-dilution-lines">
                                        <tr class="ix-table-row-secondary overhead-dilution-group">
                                            <td colspan="11">
                                                <i class="far fa-percent mr-1"></i>
                                                <span class="ix-trade-line-title">Dépenses réparties</span>
                                                <span class="ix-text-small ix-text-secondary ml-1">Lignes créées automatiquement, non modifiables</span>
                                            </td>
                                        </tr>
                                        <tr v-for="line in lot.dilution_lines" :key="'dilution-' + line.id">
                                            <td class="text-center">
                                                <span v-b-tooltip.hover title="Ligne créée automatiquement par une dépense. Pour la changer, modifiez la dépense."><i class="far fa-lock"></i></span>
                                            </td>
                                            <td></td>
                                            <td>{{ predictionTypeLabel(line.type) }}</td>
                                            <td>{{ line.reference }}</td>
                                            <td>
                                                {{ dilutionLineDesignation(line) }}
                                                <span class="badge badge-warning ml-1" v-if="isStaleDilution(line)" v-b-tooltip.hover :title="staleDilutionTitle(line)"><i class="fas fa-exclamation-triangle"></i> Répartition à mettre à jour</span>
                                                <span class="badge badge-warning ml-1" v-else-if="overheadDilutionEnabled === true && unsavedDilutionChanges[line.overhead_dilution_id]" v-b-tooltip.hover :title="unsavedDilutionTitle(line.overhead_dilution_id)"><i class="fas fa-sync-alt"></i> À recalculer</span>
                                            </td>
                                            <td>{{ dilutionLinePercentage(line) }}</td>
                                            <td class="text-right">{{ currency(line.amount) }}</td>
                                            <td class="text-center">{{ formatNumber(line.margin, 2) }} %</td>
                                            <td class="text-right">{{ currency(line.selling) }}</td>
                                            <td class="text-right">{{ currency(line.total_selling) }}</td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                    <tbody v-if="loading">
                                        <tr>
                                            <td colspan="100%" class="text-center">
                                                <i class="far fa-circle-notch fa-spin"></i>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                         <button type="button" class="ix-btn link" @click="addLotPredictionRow(index)"><i class="far fa-plus"></i> Nouvelle prévision</button><br>
                        <button type="button" class="ix-btn link" @click="openModalService()"><i class="far fa-plus"></i> Ajouter une prestation</button><br>
                        <button type="button" class="ix-btn link" v-if="canSwitchLotMode" @click="switchToNoLotMode()"><i class="far fa-exchange"></i> Passer en mode non alloti</button>
                          
                        </div>
                    </div>
                    <prediction-lot-synthesis-form :lot="lot" :index="index" :is-deal="isDeal" :prediction-types="predictionTypes" :refs="$refs"></prediction-lot-synthesis-form>
                    
                </div>
                </div>
            </div>
        </div>

       





        <div class="row" v-show="!isLotMode">
           
            <div class="col-sm-12">
                <div class="ix-table-box mb-3">
                    <table class="ix-table">
                        <thead>
                            <tr>
                                <th style="width: 30px;"></th>
                                <th style="width: 30px;">
                                    <span data-toggle="tooltip" data-placement="top" title="Définir comme titre"><i class="far fa-text"></i></span>
                                </th>
                                <th style="width: 150px;">Catégorie</th>
                                <th style="width: 150px;">Référence</th>
                                <th>Désignation</th>
                                <th style="width: 120px;">Qté</th>
                                <th class="text-right" style="width: 180px;">Prix de revient HT</th>
                                <th class="text-center" style="width: 130px;">
                                    Tx {{ margin_type == 2 ? 'marque' : 'marge' }}
                                </th>
                                <th class="text-right" style="width: 180px;">Prix de vente HT</th>
                                <th class="text-right" style="width: 180px;">Total vente HT</th>
                                <th style="width: 160px;"></th>
                            </tr>
                        </thead>
                        <draggable v-model="predictions" tag="tbody" handle=".handle-line" v-if="!loading">
                            <tr v-for="(prediction, index) in predictions" is="prediction-form"
                                v-bind:key="prediction.uniq"
                                :ref="prediction.uniq"
                                :prediction="prediction"
                                :index="index"
                                :suggestionsRoute="suggestionsRoute"
                                :types="JSON.parse(predictionTypes)"
                                :purchase-types="JSON.parse(purchaseTypes)"
                                :default-margin-workforce="margin_workforce"
                                :default-margin-purchases="margin_purchases"
                                :default-margin-stocks="margin_stocks"
                                :default-margin-equipments="margin_equipments"
                                :default-hourly-rate="default_hourly_rate"
                                :margin-type="margin_type"
                                :can-hide="canHidePrediction(prediction)"
                                :shows-hidden-flag="showsHiddenFlag(prediction)"
                                :can-toggle-optional="canEditOptions"
                                v-on:prediction-editing-started="checkIfNewRowNeeded($event)"
                                v-on:prediction-deleted="deleteRow($event)"
                                v-on:prediction-toggle-optional="togglePredictionOptional($event)"
                            ></tr>
                        </draggable>
                        <tbody v-if="loading">
                            <tr>
                                <td colspan="100%" class="text-center">
                                    <i class="far fa-circle-notch fa-spin"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <button type="button" class="ix-btn link" @click="addRow(null)"><i class="far fa-plus"></i> Nouvelle prévision</button><br>
                <button type="button" class="ix-btn link" v-if="canEditOptions" @click="addRow(null, true)"><i class="far fa-plus"></i> Nouvelle prévision optionnelle</button><br v-if="canEditOptions">
                <button type="button" class="ix-btn link" @click="openModalService()"><i class="far fa-plus"></i> Ajouter une prestation</button><br>
                <button type="button" class="ix-btn link" v-if="canSwitchLotMode" @click="switchToLotMode()"><i class="far fa-exchange"></i> Passer en mode alloti</button>


            </div>
        </div>

        <div v-show="!isLotMode">
            <h2 class="ix-page-title-secondary mt-4">Synthèse globale de l'étude</h2>
            <div class="row mb-4 mt-2" v-if="!loading">
                <div class="col-sm-12 col-md-12 col-lg-4 offset-lg-2" v-show="!isDeal">
                    <div class="form-group row">
                        <label for="quantity" class="col-sm-4 col-form-label">Quantité totale</label>
                        <div class="col-sm-8">
                            <div class="input-group">
                                <input type="number" class="form-control" v-model="quantity" id="quantity" name="quantity" step="0.01" min="0.01">
                                <input type="text" class="form-control" v-model="unit" id="unit" name="unit" placeholder="m2, m3, tonnes, kg.." :required="quantity != '' && quantity != null">
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="total_margin" class="col-sm-4 col-form-label">
                            Ratio
                            <span v-b-tooltip title="PV total / quantité">
                                <i class="fas fa-question-circle"></i>
                            </span>
                        </label>
                        <div class="col-sm-8 text-right">
                            <span class="ix-text-small ix-text-red" v-if="quantity == 0">Impossible de calculer le résultat sur une quantité égale à 0</span>
                            <div v-if="quantity != 0">
                                <span class="ix-text-secondary ix-text-small" v-if="ratio == null">Veuillez saisir une quantité et son unité pour permettre l'affichage du résultat</span>

                                <div v-if="ratio != null">
                                    <span class="ix-text-large ix-text-bold">{{ currency(ratio) }}</span> / {{ unit }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="total_margin" class="col-sm-4 col-form-label">
                            Marge dégagée
                            <span v-b-tooltip title="PV total - PR total">
                                <i class="fas fa-question-circle"></i>
                            </span>
                        </label>
                        <div class="col-sm-8 text-right">
                            <span class="ix-text-large ix-text-bold" :class="{ 'ix-text-red': total_margin < 0 }">{{ currency(total_margin) }}</span>
                        </div>
                    </div>

                    <hr>
                    <div class="form-group row">
                        <label for="quantity" class="col-sm-4 col-form-label">Nombre d'heures travaillées</label>
                        <div class="col-sm-8">
                            <div class="input-group">
                                <input type="number" class="form-control" v-model="hours_per_day" id="hours_per_day" name="hours_per_day" step="0.01" min="0.01" required>
                                <div class="input-group-append">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">h / j / personne</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="total_margin" class="col-sm-4 col-form-label">
                            Total d'heures prévisionnelles
                        </label>
                        <div class="col-sm-8 text-right">
                            {{ total_hours }}h soit <span class="ix-text-large ix-text-bold">{{ total_day_man }}j / personne</span>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 col-md-12 col-lg-6" v-bind:class="{'offset-lg-7': isDeal}">
                    <div class="ix-table-box">
                        <table class="ix-table">
                            <thead>
                                <tr>
                                    <th style="width: 20px;"></th>
                                    <th></th>
                                    <th class="text-right">Prix de revient HT</th>
                                    <th class="text-center" style="width: 180px;">
                                        Tx {{ margin_type == 2 ? 'marque' : 'marge' }} C.
                                        <span v-b-tooltip title="Marge conseillée">
                                            <i class="fas fa-question-circle"></i>
                                        </span>
                                    </th>
                                    <th class="text-center">
                                        Tx {{ margin_type == 2 ? 'marque' : 'marge' }} D.
                                        <span v-b-tooltip title="Marge dégagée">
                                            <i class="fas fa-question-circle"></i>
                                        </span>
                                    </th>
                                    <th class="text-right">Prix de vente HT</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-center">
                                        <i class="far fa-user"></i>
                                    </td>
                                    <td>
                                        <span class="ix-text-bold">Main d'oeuvre</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_workforce) }}</td>
                                    <td>
                                        <div class="input-group input-group-sm">
                                            <input type="number" class="form-control text-center" :class="{ 'text-danger': parseFloat(margin_workforce) < 0 }" name="margin_workforce" v-model="margin_workforce" required :min="marginBounds.min" :max="marginBounds.max" step="0.01">
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                                <button class="ix-btn ix-btn-icon transparent" type="button" @click="updatePredictionsMargin(1, margin_workforce)" :disabled="margin_workforce === '' || margin_workforce === null" :title="'Mettre à jour les prévisions de la catégorie avec ce taux de ' + (margin_type == 2 ? 'marque' : 'marge')">
                                                    <i class="far fa-sync"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <span :class="{ 'ix-text-red': avg_margin_workforce < 0 }">{{ avg_margin_workforce }}%</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_workforce_selling) }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <i class="far fa-shopping-bag"></i>
                                    </td>
                                    <td>
                                        <span class="ix-text-bold">Achats</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_purchases) }}</td>
                                    <td>
                                        <div class="input-group input-group-sm">
                                            <input type="number" class="form-control text-center" :class="{ 'text-danger': parseFloat(margin_purchases) < 0 }" name="margin_purchases" v-model="margin_purchases" required :min="marginBounds.min" :max="marginBounds.max" step="0.01">
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                                <button class="ix-btn ix-btn-icon transparent" type="button" @click="updatePredictionsMargin(2, margin_purchases)" :disabled="margin_purchases === '' || margin_purchases === null" :title="'Mettre à jour les prévisions de la catégorie avec ce taux de ' + (margin_type == 2 ? 'marque' : 'marge')">
                                                    <i class="far fa-sync"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <span :class="{ 'ix-text-red': avg_margin_purchases < 0 }">{{ avg_margin_purchases }}%</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_purchases_selling) }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <i class="far fa-cube"></i>
                                    </td>
                                    <td>
                                        <span class="ix-text-bold">Stocks</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_stocks) }}</td>
                                    <td>
                                        <div class="input-group input-group-sm">
                                            <input type="number" class="form-control text-center" :class="{ 'text-danger': parseFloat(margin_stocks) < 0 }" name="margin_stocks" v-model="margin_stocks" required :min="marginBounds.min" :max="marginBounds.max" step="0.01">
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                                <button class="ix-btn ix-btn-icon transparent" type="button" @click="updatePredictionsMargin(3, margin_stocks)" :disabled="margin_stocks === '' || margin_stocks === null" :title="'Mettre à jour les prévisions de la catégorie avec ce taux de ' + (margin_type == 2 ? 'marque' : 'marge')">
                                                    <i class="far fa-sync"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <span :class="{ 'ix-text-red': avg_margin_stocks < 0 }">{{ avg_margin_stocks }}%</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_stocks_selling) }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <i class="far fa-cog"></i>
                                    </td>
                                    <td>
                                        <span class="ix-text-bold">Matériels</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_equipments) }}</td>
                                    <td>
                                        <div class="input-group input-group-sm">
                                            <input type="number" class="form-control text-center" :class="{ 'text-danger': parseFloat(margin_equipments) < 0 }" name="margin_equipments" v-model="margin_equipments" required :min="marginBounds.min" :max="marginBounds.max" step="0.01">
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                                <button class="ix-btn ix-btn-icon transparent" type="button" @click="updatePredictionsMargin(4, margin_equipments)" :disabled="margin_equipments === '' || margin_equipments === null" :title="'Mettre à jour les prévisions de la catégorie avec ce taux de ' + (margin_type == 2 ? 'marque' : 'marge')">
                                                    <i class="far fa-sync"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <span :class="{ 'ix-text-red': avg_margin_equipments < 0 }">{{ avg_margin_equipments }}%</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_equipments_selling) }}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="ix-text-bold">{{ hasOptionalPredictions ? 'Total sans option' : 'Total' }}</td>
                                    <td class="text-right ix-text-bold">
                                        {{ currency(total) }}
                                    </td>
                                    <td></td>
                                    <td class="text-center">
                                        <span :class="{ 'ix-text-red': avg_margin < 0 }">{{ avg_margin }}%</span>
                                        <input type="hidden" name="margin_type" v-model="margin_type">
                                    </td>
                                    <td class="text-right ix-text-large ix-text-bold">
                                        {{ currency(total_selling) }}
                                    </td>
                                </tr>
                                <tr v-if="hasOptionalPredictions">
                                    <td class="text-center">
                                        <i class="far fa-plus-circle"></i>
                                    </td>
                                    <td class="ix-text-bold">Total optionnel <span class="ix-badge optional ml-1">{{ optionalCount }} option{{ optionalCount > 1 ? 's' : '' }}</span></td>
                                    <td class="text-right">{{ currency(total_optional) }}</td>
                                    <td></td>
                                    <td class="text-center">
                                        <span :class="{ 'ix-text-red': avg_optional_margin < 0 }">{{ avg_optional_margin }}%</span>
                                    </td>
                                    <td class="text-right">{{ currency(total_optional_selling) }}</td>
                                </tr>
                                <tr v-if="hasOptionalPredictions">
                                    <td></td>
                                    <td class="ix-text-bold">Total général</td>
                                    <td class="text-right ix-text-bold">{{ currency(total + total_optional) }}</td>
                                    <td></td>
                                    <td class="text-center">
                                        <span :class="{ 'ix-text-red': avg_margin_with_options < 0 }">{{ avg_margin_with_options }}%</span>
                                    </td>
                                    <td class="text-right ix-text-large ix-text-bold">{{ currency(total_selling + total_optional_selling) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>


        <import-service-list
                :serviceUrl="urlService" 
                :predictionTypes="JSON.parse(predictionTypes)"
                :purchaseTypes="JSON.parse(purchaseTypes)"
                :typeMargin="margin_type"
                v-on:inject-service-list="injectServiceList($event)"
        ></import-service-list>

        <template v-if="overheadDilutionEnabled === true && pendingDilution">
            <input type="hidden" name="overhead_dilution[operation]" :value="pendingDilution.operation" data-autosave-ignore>
            <input type="hidden" name="overhead_dilution[dilution_id]" :value="pendingDilution.dilution_id" v-if="pendingDilution.dilution_id" data-autosave-ignore>
            <input type="hidden" name="overhead_dilution[designation]" :value="pendingDilution.designation" data-autosave-ignore>
            <input type="hidden" name="overhead_dilution[amount]" :value="pendingDilution.amount" data-autosave-ignore>
            <input type="hidden" name="overhead_dilution[margin]" :value="pendingDilution.margin" data-autosave-ignore>
            <input type="hidden" name="overhead_dilution[selling]" :value="pendingDilution.selling" data-autosave-ignore>
            <input type="hidden" name="overhead_dilution[type]" :value="pendingDilution.type" data-autosave-ignore>
            <input type="hidden" name="overhead_dilution[type_secondary]" :value="pendingDilution.type_secondary" v-if="pendingDilution.type_secondary" data-autosave-ignore>
            <input type="hidden" name="overhead_dilution[mode]" :value="pendingDilution.mode" data-autosave-ignore>
            <input type="hidden" name="overhead_dilution[lots][]" v-for="position in pendingDilutionPositions" :key="'pending-dilution-lot-' + position" :value="position" data-autosave-ignore>
            <template v-if="pendingDilution.mode === 'percentage'">
                <input type="hidden" v-for="position in pendingDilutionPositions" :key="'pending-dilution-percentage-' + position" :name="'overhead_dilution[percentages][' + position + ']'" :value="pendingDilutionPercentages[position]" data-autosave-ignore>
            </template>
        </template>

        <overhead-dilution-modal
                v-if="overheadDilutionEnabled === true"
                ref="overheadDilutionModal"
                :lots="lots"
                :preview-route="overheadDilutionPreviewRoute"
                :suggestions-route="suggestionsRoute"
                :store-route="overheadDilutionStoreRoute"
                :study-id="studyId"
                :margin-type="margin_type"
                :default-margin-purchases="margin_purchases"
                :default-margins="{1: margin_workforce, 2: margin_purchases, 3: margin_stocks, 4: margin_equipments}"
                :prediction-types="JSON.parse(predictionTypes)"
                :purchase-types="JSON.parse(purchaseTypes)"
                @created="onOverheadDilutionCreated"
                @updated="onOverheadDilutionUpdated"
                @fill-lot="focusLotSynthesisField"
                @suspended-changed="dilutionSuspended = $event"
                @submit-study="submitStudyWithDilution"
                :saved-lot-values="savedLotValues"
        ></overhead-dilution-modal>

    </div>
</template>

<script>
    import PredictionForm from "./PredictionForm";
    import { marginBounds } from "./marginBounds";
    import PredictionLotForm from "./PredictionLotForm.vue";
    import PredictionLotSynthesisForm from "./PredictionLotSynthesisForm.vue";
    import PredictionLotLineForm from "./PredictionLotLineForm.vue";
    import InjectStudy from "./InjectStudy.vue"
    import draggable from 'vuedraggable';
    import Swal from "sweetalert2";
    import ImportServiceList from './ImportServiceList.vue';
    import OverheadDilutionModal from './OverheadDilutionModal.vue';

    export default {
        name: 'prediction-table-form',
        props: ['suggestionsRoute', 'oldData', 'initialData', 'predictionTypes', 'purchaseTypes', 'isDeal', 'lotRoute', 'removeLotPrediction', 'urlService', 'urlStudy', 'askLotMode', 'hiddenLinesEnabled', 'overheadDilutionEnabled', 'overheadDilutionPreviewRoute', 'overheadDilutionStoreRoute', 'overheadDilutionErrors', 'overheadDilutionConfirmation', 'studyId', 'maxInputVars', 'optionsEnabled'],
        components : {
            PredictionForm,
            PredictionLotForm,
            PredictionLotSynthesisForm,
            PredictionLotLineForm,
            draggable,
            InjectStudy,
            ImportServiceList,
            OverheadDilutionModal,
        },
        data() {
            return {
                expandedDilutionLots: {},
                loading: true,
                predictions: [],
                lots : [],

                quantity: null,
                unit: '',
                hours_per_day: 7,

                margin_type: 1,
                margin_workforce: 0,
                margin_purchases: 0,
                margin_stocks: 0,
                margin_equipments: 0,

                default_hourly_rate: 0,
                currentIndex: null,
                currentLot: null,
                canAddLot: true,
                lotMode: false,
                multiplier: 1,
                // Quotes-parts enregistrées par lot : elles ne sont pas postées et donc absentes de old()
                initialDilutionLines: {},
                dilutionStates: {},
                overheadDilutions: [],
                dilutionBusy: false,
                dilutionSuspended: false,
                pendingDilution: null,
                savedLotValues: {},
            };
        },
        watch : {
            multiplier : function(){
                if(this.multiplier < 0)
                    this.multiplier = 1;
            },
            lots: {
                deep: true,
                handler(){
                    this.syncQuantityFromLots();
                }
            },
        },
        methods : {
             openSideBar(){
                $('.sidebar-predictions').css({'display' : 'inline-block'});
            },
            canHidePrediction: function(prediction) {
                return this.hiddenLinesEnabled !== false && !this.isDeal && !(prediction.is_title != 1 && prediction.article_id);
            },
            showsHiddenFlag: function(prediction) {
                return this.hiddenLinesEnabled === false && !this.isDeal && prediction.is_hidden_from_client == 1;
            },
            selectLot: function(index, lot) {
                this.currentIndex = index;
                this.currentLot = lot;
            },
            focusLotSynthesisField: function(target) {
                var index = this.lots.indexOf(target.lot);
                if (index === -1) {
                    return;
                }

                this.selectLot(index, target.lot);

                this.$nextTick(() => {
                    var field = document.getElementById('lots[' + index + '][' + target.field + ']');
                    if (!field) {
                        return;
                    }

                    field.scrollIntoView({behavior: 'smooth', block: 'center'});
                    field.focus({preventScroll: true});
                });
            },
            lotPredictionsCount: function(lot) {
                if (!lot || !lot.predictions) return 0;
                return lot.predictions.filter(p => !p.is_title && p.designation && p.designation.trim() !== '').length;
            },
            lotTotalSelling: function(lot) {
                if (!lot || !lot.predictions) return 0;
                var sum = 0;
                this.lotLines(lot).filter(p => !p.is_title && !p.is_optional).forEach(p => sum += parseFloat(p.total_selling || 0));
                return sum;
            },
            isDilutionLine: function(prediction) {
                return prediction.overhead_dilution_id !== null && prediction.overhead_dilution_id !== undefined && prediction.overhead_dilution_id !== '';
            },
            lotLines: function(lot) {
                return lot.predictions.concat(lot.dilution_lines || []);
            },
            dilutionLineDesignation: function(line) {
                return line.dilution_display ? line.dilution_display.designation : line.designation;
            },
            dilutionLinePercentage: function(line) {
                return line.dilution_display ? line.dilution_display.percentage_label : '—';
            },
            predictionTypeLabel: function(type) {
                var found = JSON.parse(this.predictionTypes).find(item => item.value == type);
                return found ? found.label : '';
            },
            isStaleDilution: function(line) {
                var state = this.dilutionStates[line.overhead_dilution_id];
                return state !== undefined && state.stale === true;
            },
            staleDilutionTitle: function(line) {
                var reasons = this.dilutionStates[line.overhead_dilution_id].reasons.map(reason => reason.message);
                return 'Les lots ont changé depuis le dernier calcul : ' + reasons.join(' ; ') + '. Les montants affichés restent ceux du dernier calcul.';
            },
            unsavedDilutionTitle: function(dilutionId) {
                return 'Modification non enregistrée : ' + this.unsavedDilutionChanges[dilutionId].join(' ; ') + ". La répartition devra être recalculée à l'enregistrement de l'étude.";
            },
            normalizeDilutionUnit: function(unit) {
                if (unit === null || unit === undefined) {
                    return null;
                }

                var normalized = String(unit).replace(/[\s\u00A0\u202F]+/g, ' ').trim();
                if (normalized === '') {
                    return null;
                }

                return normalized.toLowerCase().replace(/²/g, '2').replace(/³/g, '3').replace(/([a-zà-öø-ÿ]) ([23])(?!\d)/g, '$1$2');
            },
            normalizeDilutionQuantity: function(quantity) {
                if (quantity === null || quantity === undefined || String(quantity).trim() === '' || isNaN(Number(quantity))) {
                    return null;
                }

                return Number(quantity);
            },
            formatNumber: function(value, decimals) {
                return (parseFloat(value) || 0).toLocaleString('fr-FR', {maximumFractionDigits: decimals});
            },
            applyOverheadDilution: function(data) {
                this.removeDilutionLines(data.dilution.id);

                (data.predictions || []).forEach(prediction => {
                    var lot = this.lots.find(item => item.id == prediction.lot_id);

                    if (!lot) {
                        return;
                    }

                    if (!lot.dilution_lines) {
                        this.$set(lot, 'dilution_lines', []);
                    }

                    lot.dilution_lines.push(prediction);
                });

                this.$set(this.dilutionStates, data.dilution.id, data.state);

                var index = this.overheadDilutions.findIndex(item => item.id == data.dilution.id);
                if (index === -1) {
                    this.overheadDilutions.push(data.dilution);
                } else {
                    this.overheadDilutions.splice(index, 1, data.dilution);
                }
            },
            removeDilutionLines: function(dilutionId) {
                this.lots.forEach(lot => {
                    if (lot.dilution_lines) {
                        lot.dilution_lines = lot.dilution_lines.filter(line => line.overhead_dilution_id != dilutionId);
                    }
                });
            },
            forgetDeletedLotInDilutions: function(lot) {
                var name = lot.name || 'Lot sans nom';

                this.overheadDilutions.forEach(dilution => {
                    if (!dilution.lot_ids.some(id => id == lot.id)) {
                        return;
                    }

                    dilution.lot_ids = dilution.lot_ids.filter(id => id != lot.id);

                    var reasons = (this.dilutionStates[dilution.id] ? this.dilutionStates[dilution.id].reasons : [])
                        .filter(reason => reason.lot_id != lot.id)
                        .concat([{code: 'lot_deleted', lot_id: lot.id, lot_name: name, expected: null, actual: null, message: 'Lot « ' + name + ' » supprimé'}])
                        .sort((left, right) => left.lot_id - right.lot_id);

                    this.$set(this.dilutionStates, dilution.id, {stale: true, reasons: reasons});
                });
            },
            dilutionLotNames: function(dilution) {
                return dilution.lot_ids.map(id => {
                    var lot = this.lots.find(item => item.id == id);
                    return lot && lot.name ? lot.name : 'Lot sans nom';
                }).join(', ');
            },
            dilutionLotList: function(dilution) {
                return dilution.lot_ids.map(id => {
                    var lot = this.lots.find(item => item.id == id);
                    return lot && lot.name ? lot.name : 'Lot sans nom';
                });
            },
            toggleDilutionLots: function(id) {
                this.$set(this.expandedDilutionLots, id, !this.expandedDilutionLots[id]);
            },
            editOverheadDilution: function(dilution) {
                if (this.pendingDilution) {
                    if (this.pendingDilution.operation === 'update' && this.pendingDilution.dilution_id == dilution.id) {
                        this.resumePendingDilution();
                    } else {
                        this.warnPendingDilution();
                    }

                    return;
                }

                this.$refs.overheadDilutionModal.openForEdit(dilution);
            },
            dilutionLotKey: function(lot) {
                return lot.id ? 'lot-' + lot.id : 'new-' + lot.uniq;
            },
            // Lots de la modale : {position, percentage} ; lots de l'old input : positions, pourcentages par position
            setPendingDilution: function(operation, notice) {
                var update = operation.operation === 'update';
                var percentages = operation.percentages || {};
                var lots = [];

                (operation.lots || []).forEach(item => {
                    var detailed = item !== null && typeof item === 'object';
                    var position = Number(detailed ? item.position : item);
                    var lot = this.lots[position];
                    if (!lot) {
                        return;
                    }

                    var percentage = detailed ? item.percentage : percentages[position];
                    lots.push({key: this.dilutionLotKey(lot), name: lot.name || 'Lot sans nom', percentage: percentage === undefined ? null : percentage});
                });

                this.pendingDilution = {
                    operation: update ? 'update' : 'create',
                    dilution_id: update ? operation.dilution_id : null,
                    designation: operation.designation || '',
                    amount: operation.amount,
                    margin: operation.margin,
                    selling: operation.selling,
                    type: operation.type ? String(operation.type) : '2',
                    type_secondary: operation.type_secondary ? String(operation.type_secondary) : '',
                    mode: operation.mode === 'percentage' ? 'percentage' : 'quantity',
                    lots: lots,
                    notice: notice || null,
                };
            },
            pendingDilutionTarget: function() {
                return this.pendingDilution && this.pendingDilution.dilution_id
                    ? this.overheadDilutions.find(item => item.id == this.pendingDilution.dilution_id)
                    : null;
            },
            resumePendingDilution: function(message) {
                var modal = this.$refs.overheadDilutionModal;
                if (modal.suspended) {
                    modal.resume();
                    return;
                }

                var dilution = this.pendingDilutionTarget();
                if (this.pendingDilution.operation === 'update' && !dilution) {
                    Swal.fire({title: 'Dépense introuvable', text: "La dépense « " + this.pendingDilution.designation + " » n'existe plus dans l'étude. Abandonnez cette modification.", icon: 'error', confirmButtonText: 'OK', heightAuto: false});
                    return;
                }

                modal.openPending(Object.assign({}, this.pendingDilution, {lots: this.pendingDilutionPositions, percentages: this.pendingDilutionPercentages}), dilution, message || null);
            },
            warnPendingDilution: function() {
                Swal.fire({
                    title: "Dépense en attente d'enregistrement",
                    text: "La dépense « " + this.pendingDilution.designation + " » n'est pas encore enregistrée. Reprenez-la ou abandonnez-la avant d'en créer ou d'en modifier une autre.",
                    icon: 'info',
                    showCancelButton: true,
                    cancelButtonText: 'Fermer',
                    confirmButtonText: 'Reprendre la dépense',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.resumePendingDilution();
                    }
                });
            },
            discardPendingDilution: function() {
                Swal.fire({
                    title: 'Abandonner la dépense en attente ?',
                    text: "La saisie de la dépense « " + this.pendingDilution.designation + " » sera perdue. Les autres modifications de l'étude sont conservées.",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Retour',
                    confirmButtonText: 'Abandonner la dépense',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.clearPendingDilution();
                    }
                });
            },
            clearPendingDilution: function() {
                this.pendingDilution = null;
                this.$refs.overheadDilutionModal.reset();
            },
            blockSubmitWithoutPendingLots: function(event) {
                if (!this.pendingDilution || (this.pendingDilutionPositions.length > 0 && !this.pendingDilutionPercentageGap) || event.target !== this.$el.closest('form')) {
                    return;
                }

                event.preventDefault();
                event.stopPropagation();

                Swal.fire({
                    title: this.pendingDilutionPositions.length > 0 ? 'Répartition à corriger' : 'Dépense sans lot',
                    text: this.pendingDilutionPositions.length > 0
                        ? "Un lot de la dépense « " + this.pendingDilution.designation + " » a été supprimé : ses pourcentages ne totalisent plus 100 %. Reprenez la dépense pour les corriger, ou abandonnez-la. L'étude n'a pas été enregistrée."
                        : "La dépense « " + this.pendingDilution.designation + " » n'a plus aucun lot. Reprenez-la pour choisir au moins un lot, ou abandonnez-la. L'étude n'a pas été enregistrée.",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Fermer',
                    confirmButtonText: 'Reprendre la dépense',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.resumePendingDilution();
                    }
                });
            },
            recalculateOverheadDilution: function(dilution) {
                Swal.fire({
                    title: 'Recalculer la répartition ?',
                    text: dilution.mode === 'percentage'
                        ? 'Les montants seront recalculés avec les pourcentages de la dépense et les informations actuelles des lots.'
                        : 'Les montants seront recalculés en fonction des quantités actuelles des lots.',
                    icon: 'question',
                    showCancelButton: true,
                    cancelButtonText: 'Retour',
                    confirmButtonText: 'Recalculer',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.sendDilutionRequest(dilution, '/recalculate', 'POST', data => {
                            this.applyOverheadDilution(data);
                            this.notifyDilution('Répartition recalculée', 'Les montants des lots ont été mis à jour.');
                        });
                    }
                });
            },
            cancelOverheadDilution: function(dilution) {
                var pendingUpdate = this.pendingDilution !== null && this.pendingDilution.operation === 'update' && this.pendingDilution.dilution_id == dilution.id;

                Swal.fire({
                    title: 'Êtes-vous sûr ?',
                    text: "Annuler cette dépense supprimera ses lignes dans tous les lots concernés."
                        + (pendingUpdate ? " Sa modification en attente d'enregistrement sera également abandonnée." : '')
                        + " Continuer ?",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Retour',
                    confirmButtonText: 'Annuler la dépense',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.sendDilutionRequest(dilution, '', 'DELETE', () => {
                            this.removeDilutionLines(dilution.id);
                            this.$delete(this.dilutionStates, dilution.id);
                            this.overheadDilutions = this.overheadDilutions.filter(item => item.id != dilution.id);
                            if (pendingUpdate) {
                                this.clearPendingDilution();
                            }
                            this.notifyDilution('Dépense annulée', 'Ses lignes ont été retirées des lots concernés.');
                        });
                    }
                });
            },
            sendDilutionRequest: function(dilution, suffix, method, onSuccess) {
                this.dilutionBusy = true;

                fetch(this.overheadDilutionStoreRoute + '/' + dilution.id + suffix, {
                    ...{
                        method: method,
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then(async (response) => {
                    var data = await response.json().catch(() => ({}));

                    if (response.ok) {
                        onSuccess(data);
                        return;
                    }

                    var message = response.status === 422 && data.message ? data.message
                        : response.status === 403 ? "Vous n'avez pas les droits nécessaires, ou la création de dépenses est désactivée."
                        : "L'opération n'a pas abouti. Rechargez la page puis réessayez.";
                    Swal.fire({title: 'Action impossible', text: message, icon: 'error', confirmButtonText: 'OK', heightAuto: false});
                }).catch(error => {
                    Swal.fire({title: 'Action impossible', text: 'Vérifiez votre connexion puis réessayez.', icon: 'error', confirmButtonText: 'OK', heightAuto: false});
                }).finally(() => {
                    this.dilutionBusy = false;
                });
            },
            notifyDilution: function(title, text) {
                Swal.fire({
                    title: title,
                    text: text + " Les autres modifications de l'étude restent à enregistrer.",
                    icon: 'success',
                    confirmButtonText: 'OK',
                    heightAuto: false
                });
            },
            submitStudyWithDilution: function(operation, recalculate) {
                if (operation) {
                    this.setPendingDilution(operation);
                }

                this.$nextTick(() => {
                    var form = this.$el.closest('form');
                    var fields = [];
                    var add = (name, value) => {
                        var input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = name;
                        input.value = value === null || value === undefined ? '' : value;
                        form.appendChild(input);
                        fields.push(input);
                    };

                    if (recalculate) {
                        add('recalculate_overhead_dilutions', 1);
                    }

                    var button = document.createElement('button');
                    button.type = 'submit';
                    button.hidden = true;
                    form.appendChild(button);
                    fields.push(button);

                    button.click();
                    fields.forEach(field => field.remove());
                });
            },
            confirmDilutionRecalculation: function(dilutions) {
                var escape = text => String(text).replace(/[&<>"']/g, character => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'})[character]);
                var html = "<p>Vos modifications changent la répartition d'une ou plusieurs dépenses. Elle doit être recalculée pour enregistrer l'étude.</p>"
                    + '<ul class="text-left mb-0">'
                    + dilutions.map(dilution => '<li class="mb-2"><strong>' + escape(dilution.designation) + '</strong><br>' + dilution.reasons.map(escape).join('<br>') + '</li>').join('')
                    + '</ul>';

                if (dilutions.some(dilution => this.overheadDilutions.some(item => item.id == dilution.id && item.mode === 'percentage'))) {
                    html += '<p class="mb-0 mt-2">Si un lot d\'une dépense répartie par pourcentage a été supprimé, sa part est redistribuée entre les lots restants, '
                        + 'proportionnellement à leurs pourcentages : ces pourcentages vont donc changer. Les PR et PV totaux ne changent pas.</p>';
                }

                Swal.fire({
                    title: 'Répartitions à recalculer',
                    html: html,
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Revenir',
                    confirmButtonText: 'Recalculer les répartitions et enregistrer',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.submitStudyWithDilution(null, true);
                    } else if (this.pendingDilution) {
                        this.resumePendingDilution("L'étude n'a pas été enregistrée : la répartition d'autres dépenses doit d'abord être recalculée.");
                    }
                });
            },
            onOverheadDilutionUpdated: function(data) {
                if (this.pendingDilution && this.pendingDilution.operation === 'update' && this.pendingDilution.dilution_id == data.dilution.id) {
                    this.pendingDilution = null;
                }
                this.applyOverheadDilution(data);
                this.notifyDilution('Dépense modifiée', 'Sa répartition a été mise à jour dans les lots.');
            },
            onOverheadDilutionCreated: function(data) {
                this.applyOverheadDilution(data);

                Swal.fire({
                    title: 'Dépense créée',
                    text: "La dépense a été répartie entre les lots. Pensez à enregistrer les autres modifications de l'étude.",
                    icon: 'success',
                    confirmButtonText: 'OK',
                    heightAuto: false
                });
            },
            lotIsIncomplete: function(lot) {
                return this.lotMissingItems(lot).length > 0;
            },
            lotMissingItems: function(lot) {
                var missing = [];
                if (!lot) return ['Lot non défini'];
                // Lot sans nom
                if (!lot.name || lot.name.trim() === '') missing.push('Nom du lot');
                // Quantité manquante
                if (lot.quantity === null || lot.quantity === '') missing.push('Quantité');
                // Quantité saisie sans unité
                if (lot.quantity !== null && lot.quantity !== '' && !lot.unit) missing.push('Unité');
                // Heures travaillées par jour manquantes
                if (lot.hours_per_day === null || lot.hours_per_day === '') missing.push('Heures/jour');
                // Prévisions réelles (avec désignation)
                var realPredictions = (lot.predictions || []).filter(p => !p.is_title && p.designation && p.designation.trim() !== '');
                if (realPredictions.length === 0) {
                    missing.push('Prévisions');
                } else {
                    // Une prévision sans catégorie (type) renseignée
                    var uncategorizedCount = realPredictions.filter(p => p.type === '' || p.type === null || p.type === undefined).length;
                    if (uncategorizedCount > 0) missing.push(uncategorizedCount + ' catégorie' + (uncategorizedCount > 1 ? 's' : ''));
                }
                return missing;
            },
            injectPredictions: function(event){
                if(this.lots && this.lots.length == 0 && this.predictions.findIndex(selectedPrediction => selectedPrediction.id === event.prediction.id) == -1)
                    this.addRow(event.prediction)

                if(this.lots && this.lots.length > 0 && this.lots[this.currentIndex].predictions.findIndex(selectedPrediction => selectedPrediction.id === event.prediction.id) == -1){
                    this.lots[this.currentIndex].predictions.push(event.prediction);
                }
            },
            deleteInjectPrediction: function(event){
                if(this.lots && this.lots.length == 0){
                     const index = this.predictions.findIndex(selectedPrediction => selectedPrediction.id === event.prediction_id);

                     if(index != -1)
                        this.predictions.splice(index, 1);
                }

                if(this.lots && this.lots.length > 0) {
                     const index = this.lots[this.currentIndex].predictions.findIndex(selectedPrediction => selectedPrediction.id === event.prediction_id);
                       if(index != -1)
                         this.lots[this.currentIndex].predictions.splice(index, 1);
                }
            },
            injectServiceList(event){
                var data = {
                    is_title: true,
                    designation: event.serviceList.designation + ' (x' + event.wishQuantity + ')'
                }
                if(this.lots && this.lots.length == 0){
                    this.addRow(data);
                    if(event.predictions && event.predictions.length > 0){
                        event.predictions.forEach(prediction => {
                            prediction.id = null;
                            this.addRow(prediction);
                        })
                    }
                }
                if(this.lots && this.lots.length > 0){
                    if(event.predictions && event.predictions.length > 0){
                        this.lots[this.currentIndex].predictions.push(data);
                        event.predictions.forEach(prediction => {
                            prediction.id = null;
                            this.lots[this.currentIndex].predictions.push(prediction);
                        })
                    }
                }
            },
            openModalService(){
                $('#importServiceListModal').modal();
            },
            openOverheadDilutionModal: function() {
                if (this.pendingDilution) {
                    if (this.pendingDilution.operation === 'create') {
                        this.resumePendingDilution();
                    } else {
                        this.warnPendingDilution();
                    }

                    return;
                }

                this.$refs.overheadDilutionModal.open();
            },
            duplicateLot: function(lot){
                for(let i = 0; i < this.multiplier; i++){
                    let predictions = _.cloneDeep((lot.predictions || []).filter(prediction => !this.isDilutionLine(prediction)));
                    // Un nouvel identifiant : l'autocomplete et les refs se rattachent à la ligne par son uniq
                    predictions.forEach(prediction => {
                        prediction.id = null;
                        prediction.uniq = Math.random().toString(36).substr(2, 9);
                    });

                    var data = {
                        id: null,
                        number: null,
                        name: lot.name,
                        description: lot.description,
                        quantity: lot.quantity,
                        unit: lot.unit,
                        hours_per_day: lot.hours_per_day,
                        margin_type: lot.margin_type,
                        margin_workforce: lot.margin_workforce,
                        margin_purchases: lot.margin_purchases,
                        margin_stocks: lot.margin_stocks,
                        margin_equipments: lot.margin_equipments,
                        is_optional: !!lot.is_optional,
                        default_hourly_rate: lot.default_hourly_rate,
                        predictions : predictions,
                        dilution_lines: [],
                        uniq: Math.random().toString(36).substr(2, 9)
                    };
                    this.lots.push(data);
                }
                this.multiplier = 1;
            },
            addRow: function (prediction, optional = false) {
                var data = {
                    id: null,
                    uniq: Math.random().toString(36).substr(2, 9),
                    is_title: 0,
                    is_hidden_from_client: false,
                    type: '',
                    type_secondary: 1,
                    reference: '',
                    designation: '',
                    quantity: 1,
                    unit: '',
                    amount: 0,
                    total: 0,
                    margin: 0,
                    selling: 0,
                    total_selling: 0,
                    article_id: null,
                }

                if (prediction != null) {
                    data.id = prediction.id
                    data.is_title = prediction.is_title
                    // Booléen du serveur ou "0" / "1" issu d'un old() après erreur de validation
                    data.is_hidden_from_client = prediction.is_hidden_from_client == 1
                    data.type = prediction.type == null ? '' : prediction.type
                    data.type_secondary = prediction.type_secondary == null ? '' : prediction.type_secondary
                    data.reference = prediction.reference
                    data.designation = prediction.designation
                    data.description = prediction.description
                    data.quantity = prediction.quantity
                    data.unit = prediction.unit
                    data.amount = prediction.amount
                    data.margin = prediction.margin
                    data.selling = prediction.selling
                    data.lot_id = prediction.lot_id
                    data.article_id = prediction.article_id
                    optional = !!prediction.is_optional && prediction.is_optional !== '0'
                }

                data.is_optional = this.canHaveOptionalPredictions && optional

                // Nouvelle option : « Option N », à préciser
                if (prediction == null && data.is_optional) {
                    data.designation = this.nextOptionDesignation()
                }

                // Une option ajoutée à la main se place avant la ligne vide de fin de tableau
                const last = this.predictions[this.predictions.length - 1]
                if (prediction == null && data.is_optional && last && !last.designation) {
                    this.predictions.splice(this.predictions.length - 1, 0, data)
                } else {
                    this.predictions.push(data)
                }
            },
            /** Une ligne, hors lot ou de lot, passe en option sous la désignation « Option N », ou en revient. */
            togglePredictionOptional: function (prediction) {
                const isOptional = !prediction.is_optional

                if (isOptional) {
                    prediction.designation = this.nextOptionDesignation()
                }
                this.$set(prediction, 'is_optional', isOptional)
            },
            /** « Option N » : la numérotation suit toute l'étude, lots compris. */
            nextOptionDesignation: function () {
                const predictions = this.predictions.concat(...this.lots.map(lot => lot.predictions || []))
                const max = predictions.reduce((max, prediction) => {
                    const match = /^Option (\d+)$/i.exec((prediction.designation || '').trim())
                    return match ? Math.max(max, parseInt(match[1], 10)) : max
                }, 0)

                return 'Option ' + (max + 1)
            },
            addLotRow(lot, index){
                $('.ix-tab-link').removeClass('active');
                $('.tab-pane').removeClass('active');
                this.currentIndex = index;

                var data = {
                    id: null,
                    number: null,
                    name: '',
                    description: '',
                    quantity: 1, // Volume
                    lot_quantity: 1,
                    unit: '',
                    hours_per_day: this.hours_per_day,
                    margin_type: this.margin_type,
                    margin_workforce: 0,
                    margin_purchases: 0,
                    margin_stocks: 0,
                    margin_equipments: 0,
                    is_optional: false,
                    default_hourly_rate: 0,
                    predictions : [{
                        id: null,
                        uniq: Math.random().toString(36).substr(2, 9),
                        is_title: 0,
                        type: '',
                        type_secondary: 1,
                        reference: '',
                        designation: '',
                        quantity: lot ? lot.lot_quantity : 1,
                        unit: '',
                        amount: 0,
                        total: 0,
                        margin: 0,
                        selling: 0,
                        total_selling: 0,
                        article_id: null,
                    }],
                    dilution_lines: [],
                    uniq: Math.random().toString(36).substr(2, 9)
                };

                if(lot != null){
                    var lines = lot.predictions || [];
                    var emptyRow = Object.assign({}, data.predictions[0], {quantity: 1});

                    data.id = lot.id;
                    data.name = lot.name;
                    data.description = lot.description;
                    // En mode alloti, l'option se décide au niveau du lot : pas de ligne optionnelle dans un lot
                    data.predictions = lines.filter(prediction => !this.isDilutionLine(prediction)).map(prediction => Object.assign(prediction, { is_optional: false }));
                    data.dilution_lines = lines.filter(prediction => this.isDilutionLine(prediction));
                    if (data.dilution_lines.length === 0 && lot.id && this.initialDilutionLines[lot.id]) {
                        data.dilution_lines = this.initialDilutionLines[lot.id];
                    }
                    if (data.predictions.length === 0) {
                        data.predictions = [emptyRow];
                    }
                    data.lot_quantity = lot.quantity
                    data.quantity = lot.lot_prediction.quantity;
                    data.unit = lot.lot_prediction.unit;
                    data.hours_per_day = lot.lot_prediction.hours_per_day;
                    data.margin_type = lot.lot_prediction.margin_type;
                    data.margin_workforce = lot.lot_prediction.margin_workforce;
                    data.margin_purchases = lot.lot_prediction.margin_purchases;
                    data.margin_stocks = lot.lot_prediction.margin_stocks;
                    data.margin_equipments = lot.lot_prediction.margin_equipments;
                    data.is_optional = !!lot.is_optional;
                }
                this.lots.push(data);
                this.predictions = [];
                this.currentLot = this.lots[this.currentIndex];
                this.lotMode = true;

            },
            lotFromOldInput: function(lot) {
                var predictions = Object.values(lot.predictions || {}).map(prediction => {
                    return Object.assign({}, prediction, {
                        id: prediction.id ? prediction.id : null,
                        uniq: Math.random().toString(36).substr(2, 9),
                        // Case à cocher absente du POST lorsqu'elle n'est pas cochée
                        is_title: prediction.is_title == 1 ? 1 : 0,
                        is_hidden_from_client: prediction.is_hidden_from_client == 1,
                        article_id: prediction.article_id ? prediction.article_id : null,
                        // Totaux non postés, déclarés ici pour rester réactifs dans les synthèses
                        total: (parseFloat(prediction.quantity) || 0) * (parseFloat(prediction.amount) || 0),
                        total_selling: (parseFloat(prediction.quantity) || 0) * (parseFloat(prediction.selling) || 0),
                    });
                });

                return {
                    id: lot.lot_id ? lot.lot_id : null,
                    name: lot.name,
                    description: lot.description,
                    quantity: lot.lot_quantity,
                    predictions: predictions,
                    lot_prediction: {
                        quantity: lot.quantity,
                        unit: lot.unit,
                        hours_per_day: lot.hours_per_day,
                        margin_type: lot.margin_type,
                        margin_workforce: lot.margin_workforce,
                        margin_purchases: lot.margin_purchases,
                        margin_stocks: lot.margin_stocks,
                        margin_equipments: lot.margin_equipments,
                    },
                };
            },
            addLotPredictionRow: function(index){
                this.lots[index].predictions.push(
                            {
                                is_optional: false,
                                id: null,
                                uniq: Math.random().toString(36).substr(2, 9),
                                is_title: 0,
                                type: '',
                                type_secondary: 1,
                                reference: '',
                                designation: '',
                                quantity: this.lots[index] ? this.lots[index].lot_quantity : 1,
                                unit: '',
                                amount: 0,
                                total: 0,
                                margin: 0,
                                selling: 0,
                                total_selling: 0,
                                article_id: null,
                            }
                        );
            },
            deleteRow: function (params) {
                if(this.predictions.length > 0 && this.lots.length == 0 && params.lot == null){
                    this.predictions.splice(params.index, 1)
                    if (this.predictions.length == 0) {
                        this.addRow()
                    }
                }
                
                if(this.lots.length > 0 && params.lot != null){
                     var lot = params.lot;
                     if(lot.predictions[params.index].id != null){
                         fetch('/api/removeLotPrediction?prediction_id=' + lot.predictions[params.index].id , {
                            ...{
                                method: 'DELETE'
                            },
                            ...this.getHttpJsonRequestHeaders()
                        }).then(async (response) => {
                            if (response.ok) {
                                lot.predictions.splice(params.index, 1);
                                 if(lot.predictions.length == 0){
                                    lot.predictions.push(
                                        {
                                            id: null,
                                            uniq: Math.random().toString(36).substr(2, 9),
                                            is_title: 0,
                                            type: '',
                                            type_secondary: 1,
                                            reference: '',
                                            designation: '',
                                            quantity: 1,
                                            unit: '',
                                            amount: 0,
                                            total: 0,
                                            margin: 0,
                                            selling: 0,
                                            total_selling: 0,
                                        }
                                    );

                                } 
                            }
                        }).catch(error => {
                            console.log(error);
                        })
                     } else {
                        lot.predictions.splice(params.index, 1);
                     }
                     if(lot.predictions.length == 0){
                         lot.predictions.push(
                            {
                                id: null,
                                uniq: Math.random().toString(36).substr(2, 9),
                                is_title: 0,
                                type: '',
                                type_secondary: 1,
                                reference: '',
                                designation: '',
                                quantity: 1,
                                unit: '',
                                amount: 0,
                                total: 0,
                                margin: 0,
                                selling: 0,
                                total_selling: 0,
                            }
                        );
                     }

                }
            },
            checkIfNewRowNeeded: function (params) {
                if (this.predictions.length > 0 && this.lots.length == 0 && params.lot == null) {
                    if (this.predictions.length - 1 == params.index) {
                        this.addRow()
                    }
                } 

                if(this.lots.length > 0 && params.lot != null){
                    if(params.lot.predictions.length - 1 == params.index){
                        this.lots[params.lotIndex].predictions.push(
                            {
                                id: null,
                                uniq: Math.random().toString(36).substr(2, 9),
                                is_title: 0,
                                type: '',
                                type_secondary: 1,
                                reference: '',
                                designation: '',
                                quantity: 1,
                                unit: '',
                                amount: 0,
                                total: 0,
                                margin: 0,
                                selling: 0,
                                total_selling: 0,
                                article_id: null,
                            }
                        );
                    }
                }
            },
            getPredictions: async function (route) {
                this.loading = true;
                fetch(route, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    data.forEach(prediction => {
                        this.addRow(prediction)
                    })
                    this.addRow(null)
                    this.loading = false
                }).catch(error => {
                    console.log(error)
                });
            },
            removeLot: function(index){
                var participating = this.lots[index].id ? this.overheadDilutions.filter(dilution => dilution.lot_ids.some(id => id == this.lots[index].id)) : [];
                if (this.overheadDilutionEnabled === true && participating.length > 0) {
                    this.removeLotWithDilutions(index, participating);
                    return;
                }

                // Option désactivée : refus immédiat, le serveur refuserait de toute façon la suppression
                if (participating.length > 0) {
                    Swal.fire({
                        title: 'Suppression impossible',
                        text: 'Ce lot est utilisé par une dépense (' + participating.map(dilution => dilution.designation).join(', ') + ') et la création de dépenses est désactivée : il ne peut pas être supprimé.',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        heightAuto: false
                    });
                    return;
                }

                Swal.fire({
                        title: 'Êtes-vous sûr ?',
                        text: "Toutes les prévisions du lot seront supprimées",
                        icon: 'warning',
                        showCancelButton: true,
                        cancelButtonText: 'Annuler',
                        confirmButtonText: 'Continuer',
                        reverseButtons: true,
                        heightAuto: false
                    }).then((result) => {
                        if (result.value) {
                            if(this.lots[index].id != null){
                                const removedLot = this.lots[index];
                                fetch('/api/removeLotPrediction?lot_id=' + this.lots[index].id , {
                                    ...{
                                        method: 'DELETE'
                                    },
                                    ...this.getHttpJsonRequestHeaders()
                                }).then(async (response) => {
                                    if (response.ok) {
                                        this.lots.splice(index, 1)
                                        this.selectLotAfterRemoval(index)
                                        this.forgetDeletedLotInDilutions(removedLot)
                                    } else if (response.status === 409 || response.status === 422) {
                                        var data = await response.json().catch(() => ({}));
                                        if (response.status === 409) {
                                            this.removeLotWithDilutions(this.lots.indexOf(removedLot), data.dilutions || []);
                                        } else {
                                            Swal.fire({title: 'Suppression impossible', text: data.message || "Le lot n'a pas pu être supprimé.", icon: 'error', confirmButtonText: 'OK', heightAuto: false});
                                        }
                                    }
                                }).catch(error => {
                                    console.log(error);
                                })
                            } else {
                                this.lots.splice(index, 1)
                                this.selectLotAfterRemoval(index)
                            }
                        }
                    })
            },
            selectLotAfterRemoval: function(index) {
                // Dernier lot supprimé : on reste en mode alloti, sans lot
                if(this.lots.length == 0){
                    this.currentLot = null;
                    this.currentIndex = null;
                } else if(index == 0 && this.lots[index]){
                    this.currentLot = this.lots[index];
                    this.currentIndex = index;
                } else {
                    this.currentLot = this.lots[this.lots.length - 1];
                    this.currentIndex = this.lots.length - 1;
                }
            },
            switchToLotMode: function() {
                this.canAddLot = true;
                this.addLotRow(null, 0);
            },
            switchToNoLotMode: function() {
                this.lotMode = false;
                this.lots = [];
                this.currentLot = null;
                this.currentIndex = null;
                this.canAddLot = false;
                this.addRow(null);
            },
            removeLotWithDilutions: function(index, dilutions) {
                var lot = this.lots[index];
                if (!lot) {
                    return;
                }

                var escape = text => String(text).replace(/[&<>"']/g, character => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'})[character]);

                var alone = this.overheadDilutions.filter(dilution => dilutions.some(item => item.id == dilution.id) && dilution.lot_ids.every(id => id == lot.id));
                if (alone.length > 0) {
                    Swal.fire({
                        title: 'Suppression impossible',
                        text: 'Ce lot est le dernier lot de la dépense « ' + alone.map(dilution => dilution.designation).join(' », « ') + " » : modifiez ou annulez d'abord cette dépense.",
                        icon: 'error',
                        confirmButtonText: 'OK',
                        heightAuto: false
                    });
                    return;
                }

                var byPercentage = dilution => this.overheadDilutions.some(item => item.id == dilution.id && item.mode === 'percentage');
                var percentageNote = dilutions.some(byPercentage)
                    ? '<p class="mb-0 mt-2">Pour une dépense répartie par pourcentage, la part de ce lot sera redistribuée entre les lots restants, '
                        + 'proportionnellement à leurs pourcentages : les pourcentages des lots restants vont donc changer. Les PR et PV totaux ne changent pas.</p>'
                    : '';

                Swal.fire({
                    title: 'Supprimer un lot utilisé par des dépenses',
                    html: '<p>Toutes les prévisions de ce lot seront supprimées. Ce lot est utilisé par les dépenses suivantes :</p>'
                        + '<ul class="text-left">' + dilutions.map(dilution => '<li><strong>' + escape(dilution.designation) + '</strong>'
                            + (byPercentage(dilution) ? ' <span class="ix-text-secondary">(répartie par pourcentage)</span>' : '') + '</li>').join('') + '</ul>'
                        + '<p class="mb-0">Leurs montants seront répartis entre les lots restants.</p>'
                        + percentageNote,
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonText: 'Supprimer et recalculer',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (!result.value) {
                        return;
                    }

                    this.dilutionBusy = true;

                    fetch('/api/removeLotPrediction?lot_id=' + lot.id + '&recalculate_overhead_dilutions=1', {
                        ...{
                            method: 'DELETE'
                        },
                        ...this.getHttpJsonRequestHeaders()
                    }).then(async (response) => {
                        var data = await response.json().catch(() => ({}));

                        if (!response.ok) {
                            Swal.fire({title: 'Suppression impossible', text: data.message || "Le lot n'a pas pu être supprimé : rechargez la page puis réessayez.", icon: 'error', confirmButtonText: 'OK', heightAuto: false});
                            return;
                        }

                        var position = this.lots.indexOf(lot);
                        if (position !== -1) {
                            this.lots.splice(position, 1);
                        }

                        (data.dilutions || []).forEach(payload => this.applyOverheadDilution(payload));

                        this.selectLotAfterRemoval(position);

                        this.notifyDilution('Lot supprimé', 'Les dépenses concernées ont été réparties entre les lots restants.');
                    }).catch(error => {
                        Swal.fire({title: 'Suppression impossible', text: 'Vérifiez votre connexion puis réessayez.', icon: 'error', confirmButtonText: 'OK', heightAuto: false});
                    }).finally(() => {
                        this.dilutionBusy = false;
                    });
                });
            },
            updatePredictionsMargin: function(type, margin) {
                var types = JSON.parse(this.predictionTypes)
                var selectedType = types.find((t) => {
                    return t.value == type
                })

                if (selectedType != undefined) {
                    Swal.fire({
                        title: 'Êtes-vous sûr ?',
                        text: "L'ensemble des taux de " + (this.margin_type == 2 ? 'marque' : 'marge') + " des prévisions de la catégorie " + selectedType.label.toLowerCase() + " passeront à " + margin + "%",
                        icon: 'warning',
                        showCancelButton: true,
                        cancelButtonText: 'Annuler',
                        confirmButtonText: 'Continuer',
                        reverseButtons: true,
                        heightAuto: false
                    }).then((result) => {
                        if (result.value) {
                            if(this.lots.length > 0){
                                this.lots.forEach(lot => {
                                    lot.predictions.filter(prediction => { return prediction.type == type }).forEach(prediction => {
                                        this.$refs[prediction.uniq][0].updateMargin(margin)
                                    });
                                })
                            } else {
                                this.predictions.filter(prediction => { return prediction.type == type }).forEach(prediction => {
                                    this.$refs[prediction.uniq][0].updateMargin(margin)
                                })
                            }
                            
                        }
                    })
                }
            },
            /** Taux de marge ou de marque selon le type de marge de l'étude. */
            marginRate: function (totalHt, totalSelling) {
                var divider = this.margin_type == 2 ? parseFloat(totalSelling) : parseFloat(totalHt);
                if (divider == 0) return 0;
                return this.roundCurrency(((totalSelling - totalHt) / divider) * 100, 2);
            },
            getPredictionsAttributeSumByType: function (type, attribute) {
                var sum = 0;
                 if(this.lots.length > 0){
                    this.baseLotLines.filter(prediction => { return prediction.type == type && !prediction.is_title }).forEach(prediction => sum += parseFloat(prediction[attribute]));
                } else 
                    this.baseRows.filter(prediction => { return prediction.type == type && !prediction.is_title }).forEach(prediction => sum += parseFloat(prediction[attribute]));
                return sum;
            },
            getPredictionsMarginsByType: function (type) {
                var margins = [];

                if(this.lots.length > 0){
                    this.baseLotPredictions.filter(prediction => { return prediction.type == type && !prediction.is_title }).forEach(prediction => margins.push(parseFloat(prediction.margin)));
                } else 
                    this.baseRows.filter(prediction => { return prediction.type == type && !prediction.is_title }).forEach(prediction => margins.push(parseFloat(prediction.margin)));

                return margins;
            },
            computeAvgMarginsByType: function (type) {
                let totalHt = 0;
                let totalSelling = 0;

                switch(type){
                    case 1:
                        totalHt = this.total_workforce;
                        totalSelling = this.total_workforce_selling;
                        break;
                    case 2:
                        totalHt = this.total_purchases;
                        totalSelling = this.total_purchases_selling;
                        break;
                    case 3:
                        totalHt = this.total_stocks;
                        totalSelling = this.total_stocks_selling;
                        break;
                    case 4:
                        totalHt = this.total_equipments;
                        totalSelling = this.total_equipments_selling;
                        break;
                }

                if (this.margin_type == 2) {
                    if (parseFloat(totalSelling) == 0) return 0;
                    return this.roundCurrency(((totalSelling - totalHt) / totalSelling) * 100, 2);
                }

                if (parseFloat(totalHt) == 0) return 0;
                return this.roundCurrency(((totalSelling - totalHt) / totalHt) * 100, 2);
            },
            /** Les champs que le navigateur enverra : PHP ignore tout ce qui dépasse max_input_vars. */
            countSubmittedFields: function(form) {
                let count = 0;

                Array.from(form.elements).forEach(element => {
                    if (!element.name || element.disabled || ['submit', 'button', 'reset', 'file'].includes(element.type)) return;
                    if ((element.type === 'checkbox' || element.type === 'radio') && !element.checked) return;

                    count += element.tagName === 'SELECT' && element.multiple
                        ? Array.from(element.options).filter(option => option.selected).length
                        : 1;
                });

                return count;
            },
            /** Au-delà de la limite, le serveur tronquerait l'étude : on bloque avant l'envoi, la saisie reste à l'écran. */
            checkFormSizeBeforeSubmit: function(event) {
                const limit = parseInt(this.maxInputVars, 10);
                if (!limit) return;

                const count = this.countSubmittedFields(event.target);
                if (count < limit) return;

                event.preventDefault();
                event.stopImmediatePropagation();

                Swal.fire({
                    title: 'Étude trop volumineuse',
                    text: "L'étude contient " + count + " champs alors que le serveur en accepte " + limit + " au maximum. L'enregistrement tronquerait les derniers lots : rien n'a été envoyé. Contactez l'administrateur pour augmenter la limite.",
                    icon: 'error',
                    confirmButtonText: 'OK',
                    heightAuto: false
                });
            },
            validateLotsBeforeSubmit: function(event) {
                if (!this.lots || this.lots.length === 0) return;

                const invalidIndex = this.lots.findIndex(lot => lot.quantity !== null && lot.quantity !== '' && !lot.unit);

                if (invalidIndex === -1) return;

                event.preventDefault();
                event.stopImmediatePropagation();

                const lot = this.lots[invalidIndex];

                this.currentIndex = invalidIndex;
                this.currentLot = lot;
                $('#' + invalidIndex + '-tab').tab('show');

                Swal.fire({
                    title: 'Unité manquante',
                    text: 'Merci de renseigner l\'unité du lot "' + lot.name + '" (une quantité a été saisie sans unité associée).',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    heightAuto: false
                }).then(() => {
                    $('#lots\\[' + invalidIndex + '\\]\\[unit\\]').focus();
                });
            },
            syncQuantityFromLots: function() {
                if (!this.lots || this.lots.length === 0) return;

                const lotsWithQuantity = this.lots.filter(lot => !lot.is_optional && lot.quantity !== null && lot.quantity !== '' && lot.unit);

                if (lotsWithQuantity.length === 0) {
                    this.quantity = null;
                    this.unit = '';
                    return;
                }

                const units = [...new Set(lotsWithQuantity.map(lot => lot.unit))];

                if (units.length === 1) {
                    this.quantity = this.roundCurrency(lotsWithQuantity.reduce((sum, lot) => sum + parseFloat(lot.quantity), 0), 2);
                    this.unit = units[0];
                } else {
                    // Unités hétérogènes entre les lots : la somme n'a pas de sens,
                    // on reprend la quantité/unité du dernier lot renseigné.
                    const lastLot = lotsWithQuantity[lotsWithQuantity.length - 1];
                    this.quantity = lastLot.quantity;
                    this.unit = lastLot.unit;
                }
            },
            // Création : choix du mode alloti / non alloti, une fois la question du brouillon réglée
            askLotModeAfterDraftDialog: function() {
                let draftDialogPending = false;
                this.$root.$emit('request-draft-dialog-status', (pending) => { draftDialogPending = pending; });

                if (!draftDialogPending) {
                    this.chooseLotMode();
                    return;
                }

                // Brouillon restauré : il porte déjà ses lots ou ses prévisions
                this.$root.$once('draft-dialog-closed', (restored) => {
                    if (!restored) this.chooseLotMode();
                });
            },
            chooseLotMode: function() {
                const choice = (mode, color, icon, label, legend) =>
                    '<button type="button" class="ix-choice-card ' + color + '" data-lot-mode="' + mode + '">'
                        + '<span class="ix-choice-card-icon"><i class="fas ' + icon + '"></i></span>'
                        + '<span class="ix-choice-card-title">' + label + '</span>'
                        + '<span class="ix-choice-card-desc">' + legend + '</span>'
                    + '</button>';

                let mode = null;

                // Pas de brouillon tant que le mode n'est pas choisi
                this.$root.$emit('autosave-pause');

                Swal.fire({
                    title: "Type d'étude",
                    html: '<div class="ix-choice-cards">'
                        + choice('none', 'green', 'fa-list', 'Étude non allotie', "Une seule liste de prévisions pour toute l'étude")
                        + choice('lots', 'blue', 'fa-puzzle-piece', 'Étude allotie', "Découpée en lots, chacun avec ses prévisions et sa synthèse")
                        + '</div>',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    heightAuto: false
                }).then(() => {
                    // Modale fermée sans choix (par une autre modale Swal) : on redemande
                    if (mode === null) {
                        this.chooseLotMode();
                        return;
                    }

                    this.$root.$emit('autosave-resume');

                    if (mode == 'lots') {
                        this.addLotRow(null, 0);
                    } else {
                        this.canAddLot = false;
                    }
                });

                Swal.getPopup().querySelectorAll('[data-lot-mode]').forEach((button) => {
                    button.addEventListener('click', () => {
                        mode = button.dataset.lotMode;
                        Swal.close();
                    });
                });
            },
            setupAutoSaveListeners: function() {
                // Écouter l'événement de demande de données
                this.$root.$on('request-prediction-data', (callback) => {
                    const predictionData = {
                        predictions: this.predictions || [],
                        lots: this.lots || [],
                        quantity: this.quantity,
                        unit: this.unit,
                        hours_per_day: this.hours_per_day,
                        margin_type: this.margin_type,
                        margin_workforce: this.margin_workforce,
                        margin_purchases: this.margin_purchases,
                        margin_stocks: this.margin_stocks,
                        margin_equipments: this.margin_equipments,
                        default_hourly_rate: this.default_hourly_rate
                    };
                    if (callback) callback(predictionData);
                });
                
                // Écouter l'événement de restauration de données
                this.$root.$on('restore-prediction-data', (formData) => {
                    this.restoreFromDraft(formData);
                });
            },
            
            restoreFromDraft(formData) {
                // Restaurer les données de base
                if (formData.predictions) {
                    try {
                        const predictions = JSON.parse(formData.predictions);
                        this.predictions = predictions;
                    } catch (e) {
                        console.log('Pas de données de prédictions à restaurer');
                    }
                }
                
                if (formData.lots) {
                    try {
                        const lots = JSON.parse(formData.lots);
                        lots.forEach(lot => {
                            var lines = lot.predictions || [];
                            var dilutionLines = lot.dilution_lines || [];

                            lines.filter(prediction => this.isDilutionLine(prediction)).forEach(share => {
                                if (!dilutionLines.some(line => line.id == share.id)) {
                                    dilutionLines.push(share);
                                }
                            });

                            lot.dilution_lines = dilutionLines;
                            lot.predictions = lines.filter(prediction => !this.isDilutionLine(prediction));
                            if (lot.predictions.length === 0) {
                                lot.predictions.push({
                                    id: null,
                                    uniq: Math.random().toString(36).substr(2, 9),
                                    is_title: 0,
                                    type: '',
                                    type_secondary: 1,
                                    reference: '',
                                    designation: '',
                                    quantity: 1,
                                    unit: '',
                                    amount: 0,
                                    total: 0,
                                    margin: 0,
                                    selling: 0,
                                    total_selling: 0,
                                    article_id: null,
                                });
                            }
                        });
                        this.lots = lots;
                    } catch (e) {
                        console.log('Pas de données de lots à restaurer');
                    }
                }
                
                // Restaurer les autres propriétés
                if (formData.quantity) this.quantity = formData.quantity;
                if (formData.unit) this.unit = formData.unit;
                if (formData.hours_per_day) this.hours_per_day = formData.hours_per_day;
                if (formData.margin_type) this.margin_type = formData.margin_type;
                if (formData.margin_workforce) this.margin_workforce = formData.margin_workforce;
                if (formData.margin_purchases) this.margin_purchases = formData.margin_purchases;
                if (formData.margin_stocks) this.margin_stocks = formData.margin_stocks;
                if (formData.margin_equipments) this.margin_equipments = formData.margin_equipments;
                if (formData.default_hourly_rate) this.default_hourly_rate = formData.default_hourly_rate;
            }
        },
        computed: {
            marginBounds: function() {
                return marginBounds(this.margin_type);
            },
            isLotMode: function() {
                return this.lotMode || this.lots.length > 0;
            },
            // Création : changement de mode possible tant que rien n'est saisi
            canSwitchLotMode: function() {
                if (!this.askLotMode) return false;

                const isFilled = prediction => prediction.designation && prediction.designation.trim() !== '';

                if (this.lots.length > 0) {
                    return this.lots.length == 1 && !this.lots[0].name && !this.lots[0].predictions.some(isFilled);
                }

                return !this.predictions.some(isFilled);
            },
            pendingDilutionPositions: function() {
                if (!this.pendingDilution) {
                    return [];
                }

                var keys = this.pendingDilution.lots.map(item => item.key);
                var positions = [];
                this.lots.forEach((lot, position) => {
                    if (keys.indexOf(this.dilutionLotKey(lot)) !== -1) {
                        positions.push(position);
                    }
                });

                return positions;
            },
            // Pourcentage de chaque lot encore présent de la dépense en attente, par position actuelle
            pendingDilutionPercentages: function() {
                var percentages = {};
                if (!this.pendingDilution) {
                    return percentages;
                }

                this.lots.forEach((lot, position) => {
                    var item = this.pendingDilution.lots.find(entry => entry.key === this.dilutionLotKey(lot));
                    if (item) {
                        percentages[position] = item.percentage;
                    }
                });

                return percentages;
            },
            // Répartition par pourcentage amputée d'un lot supprimé : le total n'est plus de 100 %
            pendingDilutionPercentageGap: function() {
                return this.pendingDilution !== null && this.pendingDilution.mode === 'percentage' && this.pendingDilutionMissingLots.length > 0;
            },
            pendingDilutionMissingLots: function() {
                if (!this.pendingDilution) {
                    return [];
                }

                var keys = this.lots.map(lot => this.dilutionLotKey(lot));

                return this.pendingDilution.lots.filter(item => keys.indexOf(item.key) === -1).map(item => item.name);
            },
            unsavedDilutionChanges: function() {
                var changes = {};

                this.lots.forEach(lot => {
                    var name = lot.name || 'Lot sans nom';

                    (lot.dilution_lines || []).forEach(line => {
                        var reasons = [];

                        if (this.normalizeDilutionQuantity(lot.quantity) !== this.normalizeDilutionQuantity(line.dilution_quantity)) {
                            var quantity = this.normalizeDilutionQuantity(lot.quantity);
                            reasons.push('Lot « ' + name + ' » : quantité ' + this.formatNumber(line.dilution_quantity, 3) + ' → ' + (quantity === null ? 'non renseignée' : this.formatNumber(quantity, 3)));
                        }

                        if (this.normalizeDilutionUnit(lot.unit) !== this.normalizeDilutionUnit(line.dilution_unit)) {
                            reasons.push('Lot « ' + name + ' » : unité ' + (line.dilution_unit || 'non renseignée') + ' → ' + (String(lot.unit || '').trim() || 'non renseignée'));
                        }

                        if (reasons.length > 0) {
                            changes[line.overhead_dilution_id] = (changes[line.overhead_dilution_id] || []).concat(reasons);
                        }
                    });
                });

                return changes;
            },
            // Les options n'existent qu'en étude non allotie, pas sur une affaire
            canHaveOptionalPredictions: function() {
                return !this.isDeal;
            },
            // Paramètre « Activer les options » : sans lui, on ne crée plus d'option, celles saisies restent
            canEditOptions: function() {
                return this.canHaveOptionalPredictions && !!this.optionsEnabled;
            },
            // Les options sont chiffrées hors des totaux de l'étude
            baseRows: function() {
                return this.predictions.filter(prediction => !prediction.is_optional);
            },
            optionalRows: function() {
                return this.predictions.filter(prediction => prediction.is_optional);
            },
            // Mode alloti, totaux : les lignes des lots normaux hors options, lignes de dilution comprises
            baseLotLines: function() {
                return this.lots.filter(lot => !lot.is_optional)
                    .reduce((lines, lot) => lines.concat(this.lotLines(lot).filter(prediction => !prediction.is_optional)), []);
            },
            // Mode alloti, heures et marges : les prévisions des lots normaux hors options, sans la dilution
            baseLotPredictions: function() {
                return this.lots.filter(lot => !lot.is_optional)
                    .reduce((lines, lot) => lines.concat(lot.predictions.filter(prediction => !prediction.is_optional)), []);
            },
            optionalLines: function() {
                if (this.lots.length == 0) {
                    return this.optionalRows;
                }

                return this.lots.reduce((lines, lot) => lines.concat(lot.is_optional ? this.lotLines(lot) : lot.predictions.filter(prediction => prediction.is_optional)), []);
            },
            // Les options renseignées, hors titres et ligne vide : un lot optionnel compte pour une
            optionalCount: function() {
                const isFilled = prediction => !prediction.is_title && prediction.designation;
                const lots = this.lots.filter(lot => lot.is_optional).length;
                const predictions = this.lots.length == 0
                    ? this.optionalRows.filter(isFilled).length
                    : this.lots.filter(lot => !lot.is_optional).reduce((count, lot) => count + lot.predictions.filter(prediction => prediction.is_optional && isFilled(prediction)).length, 0);

                return lots + predictions;
            },
            hasOptionalPredictions: function() {
                return this.optionalCount > 0;
            },
            total_optional: function() {
                var sum = 0;
                this.optionalLines.filter(prediction => !prediction.is_title).forEach(prediction => sum += parseFloat(prediction.total || 0));
                return sum;
            },
            total_optional_selling: function() {
                var sum = 0;
                this.optionalLines.filter(prediction => !prediction.is_title).forEach(prediction => sum += parseFloat(prediction.total_selling || 0));
                return sum;
            },
            avg_optional_margin: function() {
                return this.marginRate(this.total_optional, this.total_optional_selling);
            },
            avg_margin_with_options: function() {
                return this.marginRate(this.total + this.total_optional, this.total_selling + this.total_optional_selling);
            },
            activeLot: function() {
                if (this.lots && this.lots.length > 0 && this.currentIndex !== null) {
                    return this.lots[this.currentIndex];
                }
                return null;
            },
            total: function() {
                var sum = 0;
                if(this.lots.length > 0){
                    this.baseLotLines.filter(prediction => { return !prediction.is_title }).forEach(prediction => sum += parseFloat(prediction.total));
                } else
                    this.baseRows.filter(prediction => { return !prediction.is_title }).forEach(prediction => sum += parseFloat(prediction.total));
                return sum;
            },
            total_selling: function() {
                var sum = 0;
                if(this.lots.length > 0){
                    this.baseLotLines.filter(prediction => { return !prediction.is_title }).forEach(prediction => sum += parseFloat(prediction.total_selling));
                } else
                    this.baseRows.filter(prediction => { return !prediction.is_title }).forEach(prediction => sum += parseFloat(prediction.total_selling));
                
                return sum;
            },
            avg_margin: function() {
                if (this.margin_type == 2) {
                    if (parseFloat(this.total_selling) != 0) {
                        var divider = parseFloat(this.total_selling);
                    } else {
                        return 0;
                    }
                } else {
                    if (parseFloat(this.total) != 0) {
                        var divider = parseFloat(this.total);
                    } else {
                        return 0;
                    }
                }

                return this.roundCurrency((this.total_margin/divider) * 100, 2)
            },
            total_margin: function() {
                return this.total_selling - this.total
            },
            ratio: function() {
                if (this.quantity && this.unit) {
                    return this.total_selling / this.quantity;
                }

                return null;
            },
            total_hours: function() {
                var sum = 0;
                 if(this.lots.length > 0){
                    this.baseLotPredictions.filter(prediction => { return !prediction.is_title && prediction.type == 1}).forEach(prediction => sum += parseFloat(prediction.quantity));
                } else
                    this.baseRows.filter(prediction => { return !prediction.is_title && prediction.type == 1 }).forEach(prediction => sum += parseFloat(prediction.quantity));
                return sum;
            },
            total_day_man: function() {
                return this.roundCurrency(this.total_hours / this.hours_per_day, 2)
            },
            // Main d'oeuvre
            total_workforce: function() {
                return this.getPredictionsAttributeSumByType(1, 'total');
            },
            avg_margin_workforce: function() {
                return this.computeAvgMarginsByType(1);
            },
            total_workforce_selling: function() {
                return this.getPredictionsAttributeSumByType(1, 'total_selling');
            },
            // Achats
            total_purchases: function() {
                return this.getPredictionsAttributeSumByType(2, 'total');
            },
            avg_margin_purchases: function() {
                return this.computeAvgMarginsByType(2);
            },
            total_purchases_selling: function() {
                return this.getPredictionsAttributeSumByType(2, 'total_selling');
            },
            // Stock
            total_stocks: function() {
                return this.getPredictionsAttributeSumByType(3, 'total');
            },
            avg_margin_stocks: function() {
                return this.computeAvgMarginsByType(3);
            },
            total_stocks_selling: function() {
                return this.getPredictionsAttributeSumByType(3, 'total_selling');
            },
            // Matériel
            total_equipments: function() {
                return this.getPredictionsAttributeSumByType(4, 'total');
            },
            avg_margin_equipments: function() {
                return this.computeAvgMarginsByType(4);
            },
            total_equipments_selling: function() {
                return this.getPredictionsAttributeSumByType(4, 'total_selling');
            },
            
          
        },
        mounted(){
            const jsonDataBackup = JSON.parse(this.oldData)
            var jsonData = null
            this.loading = false

            if (Array.isArray(jsonDataBackup)) {
                jsonData = JSON.parse(this.initialData)
            } else {
                jsonData = jsonDataBackup

                // Le taux horaire par défaut n'est pas un champ du formulaire : il n'est fourni que par initialData
                if (jsonData.default_hourly_rate === undefined) {
                    jsonData.default_hourly_rate = JSON.parse(this.initialData).default_hourly_rate
                }

                // old() renvoie les lots sous la forme des champs postés : on les remet au format attendu par addLotRow
                if (jsonData.lots && typeof jsonData.lots === 'object') {
                    jsonData.lots = Object.values(jsonData.lots).map(lot => this.lotFromOldInput(lot))
                }
            }

            this.margin_type = jsonData.margin_type
            this.margin_workforce = jsonData.margin_workforce
            this.margin_purchases = jsonData.margin_purchases
            this.margin_stocks = jsonData.margin_stocks
            this.margin_equipments = jsonData.margin_equipments

            this.hours_per_day = jsonData.hours_per_day
            this.quantity = jsonData.quantity
            this.unit = jsonData.unit

            this.default_hourly_rate = jsonData.default_hourly_rate

            if (jsonData.predictions && Array.isArray(jsonData.predictions)) {
                if (jsonData.predictions.length == 0) {
                    this.addRow(null)
                }
                jsonData.predictions.forEach((prediction) => {
                    this.addRow(prediction)
                })

                this.canAddLot = false;
            }
            const initialLots = JSON.parse(this.initialData).lots
            const dilutionStates = JSON.parse(this.initialData).overhead_dilutions
            this.dilutionStates = dilutionStates && !Array.isArray(dilutionStates) ? dilutionStates : {}
            this.overheadDilutions = JSON.parse(this.initialData).overhead_dilution_list || []
            if (initialLots && typeof initialLots === 'object') {
                const savedLotValues = {}
                Object.values(initialLots).forEach(lot => {
                    this.initialDilutionLines[lot.id] = (lot.predictions || []).filter(prediction => this.isDilutionLine(prediction))
                    savedLotValues[lot.id] = {
                        quantity: lot.lot_prediction ? lot.lot_prediction.quantity : null,
                        unit: lot.lot_prediction ? lot.lot_prediction.unit : null,
                    }
                })
                this.savedLotValues = savedLotValues
            }

            if(jsonData.lots && typeof jsonData.lots === 'object'){
                const entries = Object.entries(jsonData.lots);
                
                entries.forEach((lot , index) => {
                    this.addLotRow(lot[1], 0);
                })

                this.currentLot = this.lots[0];
                this.syncQuantityFromLots();
            }

            if (!jsonData.predictions || !Array.isArray(jsonData.predictions)) {
                this.addRow(null)
            }

             $('.sidebar-predictions').css({'display' : 'none'});

             // Écouter les événements pour la sauvegarde automatique
             this.setupAutoSaveListeners();

             if (this.askLotMode && !jsonData.predictions && !jsonData.lots) {
                 this.askLotModeAfterDraftDialog();
             }

             const pendingDilution = !Array.isArray(jsonDataBackup) && jsonDataBackup.overhead_dilution ? jsonDataBackup.overhead_dilution : null
             const dilutionErrors = this.overheadDilutionErrors ? JSON.parse(this.overheadDilutionErrors) : []
             const dilutionConfirmation = this.overheadDilutionConfirmation ? JSON.parse(this.overheadDilutionConfirmation) : []

             if (this.overheadDilutionEnabled === true) {
                document.addEventListener('submit', this.blockSubmitWithoutPendingLots, true)
             }

             if (this.overheadDilutionEnabled === true && pendingDilution) {
                const studyErrorsOnly = dilutionErrors.length === 0 && dilutionConfirmation.length === 0
                this.setPendingDilution(pendingDilution, studyErrorsOnly ? "L'étude n'a pas été enregistrée car elle contient des erreurs. Corrigez-les puis enregistrez de nouveau." : null)
             }

             if (this.overheadDilutionEnabled === true && dilutionConfirmation.length > 0) {
                // Enregistrement en attente du recalcul des dilutions concernées
                this.$nextTick(() => this.confirmDilutionRecalculation(dilutionConfirmation))
             } else if (this.overheadDilutionEnabled === true && this.pendingDilution && dilutionErrors.length > 0) {
                this.$nextTick(() => this.resumePendingDilution(dilutionErrors.join(' ')))
             } else if (dilutionErrors.length > 0) {
                // Recalcul refusé lors d'un enregistrement normal : rien n'a été enregistré
                Swal.fire({title: 'Enregistrement impossible', text: dilutionErrors.join(' '), icon: 'error', confirmButtonText: 'OK', heightAuto: false})
             }

             // En capture : passe avant les autres écouteurs de soumission (brouillon, etc.)
             const studyForm = this.$el.closest('form');
             if (studyForm) {
                studyForm.addEventListener('submit', this.checkFormSizeBeforeSubmit, true);
             }

             // Validation manuelle : les champs requis situés dans un onglet de lot
             // inactif (display:none) ne sont pas focusables par la validation native
             // du navigateur, ce qui bloque le submit sans aucun message visible.
            /* const form = this.$el.closest('form');
             if (form) {
                form.addEventListener('submit', this.validateLotsBeforeSubmit);
             }*/
        },
        beforeDestroy() {
            document.removeEventListener('submit', this.blockSubmitWithoutPendingLots, true)
        }
    }
</script>

<style scoped>
    .overhead-dilution-lines td {
        background: var(--ix-background-light);
        color: var(--ix-font-color-secondary);
    }

    .overhead-dilution-trigger {
        background: var(--ix-blue-light);
        font-weight: 500;
    }

    .overhead-dilution-trigger:hover,
    .overhead-dilution-trigger:focus {
        background: var(--ix-btn-blue-background);
        border-color: var(--ix-btn-blue-border);
        color: white;
    }
</style>
